import * as i0 from '@angular/core';
import { Component, Input, NgModule, ChangeDetectionStrategy, Inject, InjectionToken, Optional, SkipSelf, Injectable, EventEmitter, Output, Directive, HostBinding, HostListener, Pipe, ViewEncapsulation, ViewChild, Self, ErrorHandler, VERSION, forwardRef } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
export { MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MAT_DIALOG_SCROLL_STRATEGY, MAT_DIALOG_SCROLL_STRATEGY_FACTORY, MAT_DIALOG_SCROLL_STRATEGY_PROVIDER, MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY, MatDialog, MatDialogActions, MatDialogClose, MatDialogConfig, MatDialogContainer, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { takeWhile, map } from 'rxjs/operators';
import { Md5 } from 'ts-md5';
import * as i1$2 from '@angular/common/http';
import { HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { take, Subject, BehaviorSubject, timer, map as map$1, Subscription, EMPTY, switchMap, tap } from 'rxjs';
import * as i3$1 from 'ngx-image-cropper';
import { ImageCropperModule } from 'ngx-image-cropper';
import * as i3 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
export * from '@angular/material/button';
import * as i1$3 from '@angular/forms';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup, NG_ASYNC_VALIDATORS } from '@angular/forms';
import * as i4 from '@angular/material/form-field';
import { MatFormFieldControl } from '@angular/material/form-field';
export * from '@angular/material/form-field';
import * as i5 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
export * from '@angular/material/input';
import * as i6 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
export * from '@angular/material/menu';
import * as i7 from '@angular/material/divider';
import { MatDividerModule } from '@angular/material/divider';
export * from '@angular/material/divider';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { getCountryCallingCode, getExampleNumber, parsePhoneNumberFromString, AsYouType, parsePhoneNumber } from 'libphonenumber-js';
import * as i2 from '@angular/cdk/a11y';
import { __decorate, __param } from 'tslib';
export * from '@angular/material/autocomplete';
export * from '@angular/material/checkbox';
export * from '@angular/material/datepicker';
export * from '@angular/material/radio';
export * from '@angular/material/select';
export * from '@angular/material/slider';
export * from '@angular/material/slide-toggle';
export * from '@angular/material/sidenav';
export * from '@angular/material/toolbar';
export * from '@angular/material/card';
export * from '@angular/material/expansion';
export * from '@angular/material/grid-list';
export * from '@angular/material/list';
export * from '@angular/material/stepper';
export * from '@angular/material/tabs';
export * from '@angular/material/tree';
export * from '@angular/material/button-toggle';
export * from '@angular/material/badge';
export * from '@angular/material/chips';
export * from '@angular/material/icon';
export * from '@angular/material/core';
export * from '@angular/material/progress-bar';
export * from '@angular/material/progress-spinner';
export * from '@angular/material/bottom-sheet';
export * from '@angular/material/snack-bar';
export * from '@angular/material/tooltip';
export * from '@angular/material/paginator';
export * from '@angular/material/sort';
export * from '@angular/material/table';
export * from '@angular/cdk/portal';

class FmIconComponent {
    constructor() {
        this.color = '';
    }
}
FmIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FmIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: FmIconComponent, selector: "fm-icon", inputs: { name: "name", color: "color" }, ngImport: i0, template: `<i class="{{ name }} {{ color }}" class="fm-icon" *ngIf="name"></i>`, isInline: true, styles: [":host i.fm-icon{font-size:1.4em;display:inline-block}:host i.fm-icon.white:before{color:#fff}:host i.fm-icon.neutral:before{color:#9397a8}:host i.fm-icon.primary:before{color:#0d47a1}:host i.fm-icon.warn:before{color:#bf360c}:host i.fm-icon.success:before{color:#1b5e20}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fm-icon', template: `<i class="{{ name }} {{ color }}" class="fm-icon" *ngIf="name"></i>`, styles: [":host i.fm-icon{font-size:1.4em;display:inline-block}:host i.fm-icon.white:before{color:#fff}:host i.fm-icon.neutral:before{color:#9397a8}:host i.fm-icon.primary:before{color:#0d47a1}:host i.fm-icon.warn:before{color:#bf360c}:host i.fm-icon.success:before{color:#1b5e20}\n"] }]
        }], propDecorators: { name: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

class FmIconModule {
}
FmIconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FmIconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: FmIconModule, declarations: [FmIconComponent], imports: [CommonModule], exports: [FmIconComponent] });
FmIconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmIconModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmIconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FmIconComponent],
                    imports: [CommonModule],
                    exports: [FmIconComponent],
                }]
        }] });

class FmDialogWarningComponent {
    constructor(data) {
        this.data = data;
        this.title = 'Warning';
        this.body = '';
        this.btn1 = 'yes';
        this.btn2 = 'no';
        Object.assign(this, this.data);
    }
}
FmDialogWarningComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDialogWarningComponent, deps: [{ token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
FmDialogWarningComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: FmDialogWarningComponent, selector: "fm-warning-dialog", ngImport: i0, template: "<div class=\"fm-main\">\n    <div class=\"row d-flex justify-content-between\">\n        <div class=\"col p-0\">\n            <h2 mat-dialog-title>\n                {{ data.title }}\n            </h2>\n        </div>\n        <div class=\"col-1 d-flex\">\n            <fm-icon\n                [name]=\"'fm_control_close'\"\n                color=\"primary\"\n                [mat-dialog-close]=\"false\">\n            </fm-icon>\n        </div>\n    </div>\n    <div class=\"fm-content\">\n        <mat-dialog-content>\n            <p>{{ data.body }}</p>\n        </mat-dialog-content>\n        <mat-dialog-actions class=\"row align-items-center mt-3\">\n            <button\n                class=\"col-auto mr-2 ml-auto fm-secondary\"\n                *ngIf=\"data.btn1 && data.btn1 !== ''\"\n                mat-button\n                [mat-dialog-close]=\"true\">\n                {{ data.btn1 }}\n            </button>\n            <button\n                class=\"col-auto fm-primary\"\n                *ngIf=\"data.btn2 && data.btn2 !== ''\"\n                mat-button\n                [mat-dialog-close]=\"false\">\n                {{ data.btn2 }}\n            </button>\n        </mat-dialog-actions>\n    </div>\n</div>\n", styles: [":host h2{margin:0 0 24px}:host fm-icon{cursor:pointer}:host p{margin:0}:host .mat-dialog-actions{padding:8px 0 18px;margin-top:24px 0}:host button{cursor:pointer;border:none;min-width:50px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: FmIconComponent, selector: "fm-icon", inputs: ["name", "color"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDialogWarningComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fm-warning-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"fm-main\">\n    <div class=\"row d-flex justify-content-between\">\n        <div class=\"col p-0\">\n            <h2 mat-dialog-title>\n                {{ data.title }}\n            </h2>\n        </div>\n        <div class=\"col-1 d-flex\">\n            <fm-icon\n                [name]=\"'fm_control_close'\"\n                color=\"primary\"\n                [mat-dialog-close]=\"false\">\n            </fm-icon>\n        </div>\n    </div>\n    <div class=\"fm-content\">\n        <mat-dialog-content>\n            <p>{{ data.body }}</p>\n        </mat-dialog-content>\n        <mat-dialog-actions class=\"row align-items-center mt-3\">\n            <button\n                class=\"col-auto mr-2 ml-auto fm-secondary\"\n                *ngIf=\"data.btn1 && data.btn1 !== ''\"\n                mat-button\n                [mat-dialog-close]=\"true\">\n                {{ data.btn1 }}\n            </button>\n            <button\n                class=\"col-auto fm-primary\"\n                *ngIf=\"data.btn2 && data.btn2 !== ''\"\n                mat-button\n                [mat-dialog-close]=\"false\">\n                {{ data.btn2 }}\n            </button>\n        </mat-dialog-actions>\n    </div>\n</div>\n", styles: [":host h2{margin:0 0 24px}:host fm-icon{cursor:pointer}:host p{margin:0}:host .mat-dialog-actions{padding:8px 0 18px;margin-top:24px 0}:host button{cursor:pointer;border:none;min-width:50px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

class FmDialogModule {
}
FmDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FmDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: FmDialogModule, declarations: [FmDialogWarningComponent], imports: [CommonModule, MatDialogModule, FmIconModule], exports: [FmDialogWarningComponent] });
FmDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDialogModule, imports: [CommonModule, MatDialogModule, FmIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FmDialogWarningComponent],
                    imports: [CommonModule, MatDialogModule, FmIconModule],
                    exports: [FmDialogWarningComponent],
                }]
        }] });

const FM_CONFIGS = new InjectionToken('FM_CONFIGS');

class FmThemeLibModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('FmThemeLibModule is already loaded. Import it in the AppModule only');
        }
    }
    static forRoot(configs) {
        return {
            ngModule: FmThemeLibModule,
            providers: [
                {
                    provide: FM_CONFIGS,
                    useValue: configs,
                }
            ],
        };
    }
}
FmThemeLibModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmThemeLibModule, deps: [{ token: FmThemeLibModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule });
FmThemeLibModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: FmThemeLibModule, imports: [FmDialogModule] });
FmThemeLibModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmThemeLibModule, imports: [FmDialogModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmThemeLibModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [FmDialogModule],
                }]
        }], ctorParameters: function () { return [{ type: FmThemeLibModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; } });

/**
 * Contract of all async sources.
 * Every async source must implement the processResponse method that extracts the avatar url from the data
 */
class AsyncSource {
    constructor(sourceId) {
        this.sourceId = sourceId;
    }
}

var AvatarSource;
(function (AvatarSource) {
    AvatarSource["FACEBOOK"] = "facebook";
    AvatarSource["GOOGLE"] = "google";
    AvatarSource["TWITTER"] = "twitter";
    AvatarSource["INSTAGRAM"] = "instagram";
    AvatarSource["VKONTAKTE"] = "vkontakte";
    AvatarSource["SKYPE"] = "skype";
    AvatarSource["GRAVATAR"] = "gravatar";
    AvatarSource["GITHUB"] = "github";
    AvatarSource["CUSTOM"] = "custom";
    AvatarSource["INITIALS"] = "initials";
    AvatarSource["VALUE"] = "value";
})(AvatarSource || (AvatarSource = {}));

/**
 *  Facebook source implementation.
 *  Fetch avatar source based on facebook identifier
 *  and image size
 */
class Facebook {
    constructor(sourceId) {
        this.sourceId = sourceId;
        this.sourceType = AvatarSource.FACEBOOK;
    }
    getAvatar(size) {
        return ('https://graph.facebook.com/' +
            `${this.sourceId}/picture?width=${size}&height=${size}`);
    }
}

/**
 *  Twitter source implementation.
 *  Fetch avatar source based on google identifier
 *  and image size
 */
class Twitter {
    constructor(sourceId) {
        this.sourceId = sourceId;
        this.sourceType = AvatarSource.TWITTER;
    }
    getAvatar(size) {
        const twitterImgSize = this.getImageSize(size);
        return `https://twitter.com/${this.sourceId}/profile_image?size=${twitterImgSize}`;
    }
    getImageSize(size) {
        if (size <= 24) {
            return 'mini';
        }
        if (size <= 48) {
            return 'normal';
        }
        if (size <= 73) {
            return 'bigger';
        }
        return 'original';
    }
}

/**
 *  Google source implementation.
 *  Fetch avatar source based on google identifier
 *  and image size
 */
class Google extends AsyncSource {
    constructor(sourceId) {
        super(sourceId);
        this.sourceType = AvatarSource.GOOGLE;
    }
    getAvatar() {
        return `https://picasaweb.google.com/data/entry/api/user/${this.sourceId}?alt=json`;
    }
    /**
     * Extract google avatar from json data
     */
    processResponse(data, size) {
        const avatarSrc = data.entry.gphoto$thumbnail.$t;
        if (avatarSrc) {
            return avatarSrc.replace('s64', 's' + size);
        }
        return null;
    }
}

/**
 *  Instagram source impelementation.
 *  Fetch avatar source based on instagram identifier
 */
class Instagram extends AsyncSource {
    constructor(sourceId) {
        super(sourceId);
        this.sourceType = AvatarSource.INSTAGRAM;
    }
    getAvatar() {
        return `https://www.instagram.com/${this.sourceId}/?__a=1`;
    }
    /**
     * extract instagram avatar from json data
     */
    processResponse(data, size) {
        return `${data.graphql.user.profile_pic_url_hd}&s=${size}`;
    }
}

/**
 *  Custom source implementation.
 *  return custom image as an avatar
 *
 */
class Custom {
    constructor(sourceId) {
        this.sourceId = sourceId;
        this.sourceType = AvatarSource.CUSTOM;
    }
    getAvatar() {
        return this.sourceId;
    }
}

/**
 * Initials source implementation.
 * return the initials of the given value
 */
class Initials {
    constructor(sourceId) {
        this.sourceId = sourceId;
        this.sourceType = AvatarSource.INITIALS;
    }
    getAvatar(size) {
        return this.getInitials(this.sourceId, size);
    }
    /**
     * Returns the initial letters of a name in a string.
     */
    getInitials(name, size) {
        name = name.trim();
        if (!name) {
            return '';
        }
        const initials = name.split(' ');
        if (size && size < initials.length) {
            return this.constructInitials(initials.slice(0, size));
        }
        else {
            return this.constructInitials(initials);
        }
    }
    /**
     * Iterates a person's name string to get the initials of each word in uppercase.
     */
    constructInitials(elements) {
        if (!elements || !elements.length) {
            return '';
        }
        return elements
            .filter(element => element && element.length > 0)
            .map(element => element[0].toUpperCase())
            .join('');
    }
}

function isRetina() {
    if (typeof window !== 'undefined' && window !== null) {
        if (window.devicePixelRatio > 1.25) {
            return true;
        }
        const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.25), (min--moz-device-pixel-ratio: 1.25), (-o-min-device-pixel-ratio: 5/4), (min-resolution: 1.25dppx)';
        if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
            return true;
        }
    }
    return false;
}
/**
 *  Gravatar source implementation.
 *  Fetch avatar source based on gravatar email
 */
class Gravatar {
    constructor(value) {
        this.value = value;
        this.sourceType = AvatarSource.GRAVATAR;
        this.sourceId = value.match('^[a-f0-9]{32}$')
            ? value
            : Md5.hashStr(value).toString();
    }
    getAvatar(size) {
        const avatarSize = isRetina() ? size * 2 : size;
        return `https://secure.gravatar.com/avatar/${this.sourceId}?s=${avatarSize}&d=404`;
    }
}

/**
 *  Skype source implementation.
 *  Fetch avatar source based on skype identifier
 */
class Skype {
    constructor(sourceId) {
        this.sourceId = sourceId;
        this.sourceType = AvatarSource.SKYPE;
    }
    getAvatar() {
        return `https://api.skype.com/users/${this.sourceId}/profile/avatar`;
    }
}

/**
 *  Value source implementation.
 *  return the value as avatar
 */
class Value {
    constructor(sourceId) {
        this.sourceId = sourceId;
        this.sourceType = AvatarSource.VALUE;
    }
    getAvatar() {
        return this.sourceId;
    }
}

/**
 *  Vkontakte source implementation.
 *  Fetch avatar source based on vkontakte identifier
 *  and image size
 */
const apiVersion = 5.8;
class Vkontakte extends AsyncSource {
    constructor(sourceId) {
        super(sourceId);
        this.sourceType = AvatarSource.VKONTAKTE;
    }
    getAvatar(size) {
        const imgSize = this.getImageSize(size);
        return `https://api.vk.com/method/users.get?user_id=${this.sourceId}&v=${apiVersion}&fields=${imgSize}`;
    }
    /**
     * extract vkontakte avatar from json data
     */
    processResponse(data) {
        // avatar key property is the size used to generate avatar url
        // size property is always the last key in the response object
        const sizeProperty = Object.keys(data['response'][0]).pop();
        if (!sizeProperty) {
            return null;
        }
        // return avatar src
        return data['response'][0][sizeProperty] || null;
    }
    /**
     * Returns image size related to vkontakte API
     */
    getImageSize(size) {
        if (size <= 50) {
            return 'photo_50';
        }
        if (size <= 100) {
            return 'photo_100';
        }
        if (size <= 200) {
            return 'photo_200';
        }
        return 'photo_max';
    }
}

/**
 *  GitHub source implementation.
 *  Fetch avatar source based on github identifier
 */
class Github extends AsyncSource {
    constructor(sourceId) {
        super(sourceId);
        this.sourceType = AvatarSource.GITHUB;
    }
    getAvatar() {
        return `https://api.github.com/users/${this.sourceId}`;
    }
    /**
     * extract github avatar from json data
     */
    processResponse(data, size) {
        if (size) {
            return `${data.avatar_url}&s=${size}`;
        }
        return data.avatar_url;
    }
}

/**
 * Factory class that implements factory method pattern.
 * Used to create Source implementation class based
 * on the source Type
 */
class SourceFactory {
    constructor() {
        this.sources = {};
        this.sources[AvatarSource.FACEBOOK] = Facebook;
        this.sources[AvatarSource.TWITTER] = Twitter;
        this.sources[AvatarSource.GOOGLE] = Google;
        this.sources[AvatarSource.INSTAGRAM] = Instagram;
        this.sources[AvatarSource.SKYPE] = Skype;
        this.sources[AvatarSource.GRAVATAR] = Gravatar;
        this.sources[AvatarSource.CUSTOM] = Custom;
        this.sources[AvatarSource.INITIALS] = Initials;
        this.sources[AvatarSource.VALUE] = Value;
        this.sources[AvatarSource.VKONTAKTE] = Vkontakte;
        this.sources[AvatarSource.GITHUB] = Github;
    }
    newInstance(sourceType, sourceValue) {
        return new this.sources[sourceType](sourceValue);
    }
}
SourceFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: SourceFactory, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SourceFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: SourceFactory });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: SourceFactory, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

/**
 * Token used to inject the AvatarConfig object
 */
const AVATAR_CONFIG = new InjectionToken('avatar.config');

class AvatarConfigService {
    constructor(userConfig) {
        this.userConfig = userConfig;
    }
    getAvatarSources(defaultSources) {
        if (this.userConfig &&
            this.userConfig.sourcePriorityOrder &&
            this.userConfig.sourcePriorityOrder.length) {
            const uniqueSources = [...new Set(this.userConfig.sourcePriorityOrder)];
            const validSources = uniqueSources.filter(source => defaultSources.includes(source));
            return [
                ...validSources,
                ...defaultSources.filter(source => !validSources.includes(source))
            ];
        }
        return defaultSources;
    }
    getAvatarColors(defaultColors) {
        return ((this.userConfig &&
            this.userConfig.colors &&
            this.userConfig.colors.length &&
            this.userConfig.colors) ||
            defaultColors);
    }
}
AvatarConfigService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AvatarConfigService, deps: [{ token: AVATAR_CONFIG, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
AvatarConfigService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AvatarConfigService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AvatarConfigService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [AVATAR_CONFIG]
                }] }]; } });

/**
 * list of Supported avatar sources
 */
const defaultSources = [
    AvatarSource.FACEBOOK,
    AvatarSource.GOOGLE,
    AvatarSource.TWITTER,
    AvatarSource.INSTAGRAM,
    AvatarSource.VKONTAKTE,
    AvatarSource.SKYPE,
    AvatarSource.GRAVATAR,
    AvatarSource.GITHUB,
    AvatarSource.CUSTOM,
    AvatarSource.INITIALS,
    AvatarSource.VALUE
];
/**
 * list of default colors
 */
const defaultColors = [
    '#1abc9c',
    '#3498db',
    '#f1c40f',
    '#8e44ad',
    '#e74c3c',
    '#d35400',
    '#2c3e50',
    '#7f8c8d'
];
/**
 * Provides utilities methods related to Avatar component
 */
class AvatarService {
    constructor(http, avatarConfigService) {
        this.http = http;
        this.avatarConfigService = avatarConfigService;
        this.avatarSources = defaultSources;
        this.avatarColors = defaultColors;
        this.failedSources = new Map();
        this.overrideAvatarSources();
        this.overrideAvatarColors();
    }
    fetchAvatar(avatarUrl) {
        return this.http.get(avatarUrl);
    }
    getRandomColor(avatarText) {
        if (!avatarText) {
            return 'transparent';
        }
        const asciiCodeSum = this.calculateAsciiCode(avatarText);
        return this.avatarColors[asciiCodeSum % this.avatarColors.length];
    }
    compareSources(sourceType1, sourceType2) {
        return (this.getSourcePriority(sourceType1) - this.getSourcePriority(sourceType2));
    }
    isSource(source) {
        return this.avatarSources.includes(source);
    }
    isTextAvatar(sourceType) {
        return [AvatarSource.INITIALS, AvatarSource.VALUE].includes(sourceType);
    }
    buildSourceKey(source) {
        return source.sourceType + '-' + source.sourceId;
    }
    sourceHasFailedBefore(source) {
        return this.failedSources.has(this.buildSourceKey(source));
    }
    markSourceAsFailed(source) {
        this.failedSources.set(this.buildSourceKey(source), source);
    }
    overrideAvatarSources() {
        this.avatarSources = this.avatarConfigService.getAvatarSources(defaultSources);
    }
    overrideAvatarColors() {
        this.avatarColors = this.avatarConfigService.getAvatarColors(defaultColors);
    }
    calculateAsciiCode(value) {
        return value
            .split('')
            .map(letter => letter.charCodeAt(0))
            .reduce((previous, current) => previous + current);
    }
    getSourcePriority(sourceType) {
        return this.avatarSources.indexOf(sourceType);
    }
}
AvatarService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AvatarService, deps: [{ token: i1$2.HttpClient }, { token: AvatarConfigService }], target: i0.ɵɵFactoryTarget.Injectable });
AvatarService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AvatarService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AvatarService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.HttpClient }, { type: AvatarConfigService }]; } });

/**
 * Universal avatar component that
 * generates avatar from different sources
 *
 * export
 * class AvatarComponent
 * implements {OnChanges}
 */
class AvatarComponent {
    constructor(sourceFactory, avatarService) {
        this.sourceFactory = sourceFactory;
        this.avatarService = avatarService;
        this.round = true;
        this.size = 50;
        this.textSizeRatio = 3;
        this.fgColor = '#FFF';
        this.style = {};
        this.cornerRadius = 0;
        this.initialsSize = 0;
        this.clickOnAvatar = new EventEmitter();
        this.isAlive = true;
        this.avatarSrc = null;
        this.avatarText = null;
        this.avatarStyle = {};
        this.hostStyle = {};
        this.currentIndex = -1;
        this.sources = [];
    }
    onAvatarClicked() {
        this.clickOnAvatar.emit(this.sources[this.currentIndex]);
    }
    /**
     * Detect inputs change
     *
     * param {{ [propKey: string]: SimpleChange }} changes
     *
     * memberof AvatarComponent
     */
    ngOnChanges(changes) {
        for (const propName in changes) {
            if (this.avatarService.isSource(propName)) {
                const sourceType = AvatarSource[propName.toUpperCase()];
                const currentValue = changes[propName].currentValue;
                if (currentValue && typeof currentValue === 'string') {
                    this.addSource(sourceType, currentValue);
                }
                else {
                    this.removeSource(sourceType);
                }
            }
        }
        // reinitialize the avatar component when a source property value has changed
        // the fallback system must be re-invoked with the new values.
        this.initializeAvatar();
    }
    /**
     * Fetch avatar source
     *
     * memberOf AvatarComponent
     */
    fetchAvatarSource() {
        const previousSource = this.sources[this.currentIndex];
        if (previousSource) {
            this.avatarService.markSourceAsFailed(previousSource);
        }
        const source = this.findNextSource();
        if (!source) {
            return;
        }
        if (this.avatarService.isTextAvatar(source.sourceType)) {
            this.buildTextAvatar(source);
            this.avatarSrc = null;
        }
        else {
            this.buildImageAvatar(source);
        }
    }
    findNextSource() {
        while (++this.currentIndex < this.sources.length) {
            const source = this.sources[this.currentIndex];
            if (source && !this.avatarService.sourceHasFailedBefore(source)) {
                return source;
            }
        }
        return null;
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    /**
     * Initialize the avatar component and its fallback system
     */
    initializeAvatar() {
        this.currentIndex = -1;
        if (this.sources.length > 0) {
            this.sortAvatarSources();
            this.fetchAvatarSource();
            this.hostStyle = {
                width: this.size + 'px',
                height: this.size + 'px'
            };
        }
    }
    sortAvatarSources() {
        this.sources.sort((source1, source2) => this.avatarService.compareSources(source1.sourceType, source2.sourceType));
    }
    buildTextAvatar(avatarSource) {
        this.avatarText = avatarSource.getAvatar(+this.initialsSize);
        this.avatarStyle = this.getInitialsStyle(avatarSource.sourceId);
    }
    buildImageAvatar(avatarSource) {
        this.avatarStyle = this.getImageStyle();
        if (avatarSource instanceof AsyncSource) {
            this.fetchAndProcessAsyncAvatar(avatarSource);
        }
        else {
            this.avatarSrc = avatarSource.getAvatar(+this.size);
        }
    }
    /**
     *
     * returns initials style
     *
     * memberOf AvatarComponent
     */
    getInitialsStyle(avatarValue) {
        return {
            textAlign: 'center',
            borderRadius: this.round ? '100%' : this.cornerRadius + 'px',
            border: this.borderColor ? '1px solid ' + this.borderColor : '',
            textTransform: 'uppercase',
            color: this.fgColor,
            backgroundColor: this.bgColor
                ? this.bgColor
                : this.avatarService.getRandomColor(avatarValue),
            font: Math.floor(+this.size / this.textSizeRatio) +
                'px Helvetica, Arial, sans-serif',
            lineHeight: this.size + 'px',
            ...this.style
        };
    }
    /**
     *
     * returns image style
     *
     * memberOf AvatarComponent
     */
    getImageStyle() {
        return {
            maxWidth: '100%',
            borderRadius: this.round ? '50%' : this.cornerRadius + 'px',
            border: this.borderColor ? '1px solid ' + this.borderColor : '',
            width: this.size + 'px',
            height: this.size + 'px',
            ...this.style,
        };
    }
    /**
     * Fetch avatar image asynchronously.
     *
     * param {Source} source represents avatar source
     * memberof AvatarComponent
     */
    fetchAndProcessAsyncAvatar(source) {
        if (this.avatarService.sourceHasFailedBefore(source)) {
            return;
        }
        this.avatarService
            .fetchAvatar(source.getAvatar(+this.size))
            .pipe(takeWhile(() => this.isAlive), map(response => source.processResponse(response, +this.size)))
            .subscribe(avatarSrc => (this.avatarSrc = avatarSrc), err => {
            this.fetchAvatarSource();
        });
    }
    /**
     * Add avatar source
     *
     * param sourceType avatar source type e.g facebook,twitter, etc.
     * param sourceValue  source value e.g facebookId value, etc.
     */
    addSource(sourceType, sourceValue) {
        const source = this.sources.find(s => s.sourceType === sourceType);
        if (source) {
            source.sourceId = sourceValue;
        }
        else {
            this.sources.push(this.sourceFactory.newInstance(sourceType, sourceValue));
        }
    }
    /**
     * Remove avatar source
     *
     * param sourceType avatar source type e.g facebook,twitter, etc.
     */
    removeSource(sourceType) {
        this.sources = this.sources.filter(source => source.sourceType !== sourceType);
    }
}
AvatarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AvatarComponent, deps: [{ token: SourceFactory }, { token: AvatarService }], target: i0.ɵɵFactoryTarget.Component });
AvatarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: AvatarComponent, selector: "ngx-avatar", inputs: { round: "round", size: "size", textSizeRatio: "textSizeRatio", bgColor: "bgColor", fgColor: "fgColor", borderColor: "borderColor", style: "style", cornerRadius: "cornerRadius", facebook: ["facebookId", "facebook"], twitter: ["twitterId", "twitter"], google: ["googleId", "google"], instagram: ["instagramId", "instagram"], vkontakte: ["vkontakteId", "vkontakte"], skype: ["skypeId", "skype"], gravatar: ["gravatarId", "gravatar"], github: ["githubId", "github"], custom: ["src", "custom"], initials: ["name", "initials"], value: "value", placeholder: "placeholder", initialsSize: "initialsSize" }, outputs: { clickOnAvatar: "clickOnAvatar" }, usesOnChanges: true, ngImport: i0, template: `
    <div
      (click)="onAvatarClicked()"
      class="avatar-container"
      [ngStyle]="hostStyle"
    >
      <img
        *ngIf="avatarSrc; else textAvatar"
        [src]="avatarSrc"
        [width]="size"
        [height]="size"
        [ngStyle]="avatarStyle"
        (error)="fetchAvatarSource()"
        class="avatar-content"
        loading="lazy"
      />
      <ng-template #textAvatar>
        <div *ngIf="avatarText" class="avatar-content" [ngStyle]="avatarStyle">
          {{ avatarText }}
        </div>
      </ng-template>
    </div>
  `, isInline: true, styles: [":host{border-radius:50%}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ngx-avatar', template: `
    <div
      (click)="onAvatarClicked()"
      class="avatar-container"
      [ngStyle]="hostStyle"
    >
      <img
        *ngIf="avatarSrc; else textAvatar"
        [src]="avatarSrc"
        [width]="size"
        [height]="size"
        [ngStyle]="avatarStyle"
        (error)="fetchAvatarSource()"
        class="avatar-content"
        loading="lazy"
      />
      <ng-template #textAvatar>
        <div *ngIf="avatarText" class="avatar-content" [ngStyle]="avatarStyle">
          {{ avatarText }}
        </div>
      </ng-template>
    </div>
  `, styles: [":host{border-radius:50%}\n"] }]
        }], ctorParameters: function () { return [{ type: SourceFactory }, { type: AvatarService }]; }, propDecorators: { round: [{
                type: Input
            }], size: [{
                type: Input
            }], textSizeRatio: [{
                type: Input
            }], bgColor: [{
                type: Input
            }], fgColor: [{
                type: Input
            }], borderColor: [{
                type: Input
            }], style: [{
                type: Input
            }], cornerRadius: [{
                type: Input
            }], facebook: [{
                type: Input,
                args: ['facebookId']
            }], twitter: [{
                type: Input,
                args: ['twitterId']
            }], google: [{
                type: Input,
                args: ['googleId']
            }], instagram: [{
                type: Input,
                args: ['instagramId']
            }], vkontakte: [{
                type: Input,
                args: ['vkontakteId']
            }], skype: [{
                type: Input,
                args: ['skypeId']
            }], gravatar: [{
                type: Input,
                args: ['gravatarId']
            }], github: [{
                type: Input,
                args: ['githubId']
            }], custom: [{
                type: Input,
                args: ['src']
            }], initials: [{
                type: Input,
                args: ['name']
            }], value: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], initialsSize: [{
                type: Input
            }], clickOnAvatar: [{
                type: Output
            }] } });

class FmAvatarComponent {
    constructor() {
        this.viewMode = 'individual';
        this.size = 64;
        this.initialsSize = 2;
    }
    ngOnInit() { }
}
FmAvatarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmAvatarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FmAvatarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: FmAvatarComponent, selector: "fm-avatar", inputs: { viewMode: "viewMode", size: "size", user: "user", medicalGroup: "medicalGroup" }, ngImport: i0, template: "<ng-container [ngSwitch]=\"viewMode\">\n    <!-- Individual avatar -->\n    <ng-container *ngSwitchCase=\"'individual'\">\n        <ngx-avatar [name]=\"user.name\" [src]=\"user.avatar\" [initialsSize]=\"initialsSize\" [size]=\"size\"></ngx-avatar>\n    </ng-container>\n\n    <!-- Individual in a Group avatar -->\n    <ng-container *ngSwitchCase=\"'individual-group'\">\n        <div class=\"row fm-avatar-individual-group\">\n            <div class=\"col-auto pe-0\">\n                <ngx-avatar\n                    [name]=\"medicalGroup.name\"\n                    [src]=\"medicalGroup.avatar\"\n                    [initialsSize]=\"initialsSize\"\n                    [round]=\"false\"\n                    [cornerRadius]=\"8\"\n                    [size]=\"size\"\n                ></ngx-avatar>\n            </div>\n\n            <div class=\"col-auto ps-0\">\n                <ngx-avatar\n                    [name]=\"user.name\"\n                    [src]=\"user.avatar\"\n                    [initialsSize]=\"initialsSize\"\n                    [size]=\"size\"\n                ></ngx-avatar>\n            </div>\n        </div>\n    </ng-container>\n\n    <!-- Group avatar -->\n    <ng-container *ngSwitchCase=\"'group'\">\n        <ngx-avatar\n            [name]=\"medicalGroup.name\"\n            [src]=\"medicalGroup.avatar\"\n            [initialsSize]=\"initialsSize\"\n            [round]=\"false\"\n            [cornerRadius]=\"8\"\n            [size]=\"size\"\n        ></ngx-avatar>\n    </ng-container>\n\n    <!-- Group members avatar -->\n    <ng-container *ngSwitchCase=\"'group-members'\">\n        <div class=\"row fm-avatar-group-members\">\n            <div class=\"col-auto px-0\" *ngFor=\"let member of medicalGroup.members\">\n                <ngx-avatar\n                    [name]=\"member.name\"\n                    [src]=\"member.avatar\"\n                    [initialsSize]=\"initialsSize\"\n                    [size]=\"size\"\n                ></ngx-avatar>\n            </div>\n        </div>\n    </ng-container>\n</ng-container>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "component", type: AvatarComponent, selector: "ngx-avatar", inputs: ["round", "size", "textSizeRatio", "bgColor", "fgColor", "borderColor", "style", "cornerRadius", "facebookId", "twitterId", "googleId", "instagramId", "vkontakteId", "skypeId", "gravatarId", "githubId", "src", "name", "value", "placeholder", "initialsSize"], outputs: ["clickOnAvatar"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmAvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fm-avatar', template: "<ng-container [ngSwitch]=\"viewMode\">\n    <!-- Individual avatar -->\n    <ng-container *ngSwitchCase=\"'individual'\">\n        <ngx-avatar [name]=\"user.name\" [src]=\"user.avatar\" [initialsSize]=\"initialsSize\" [size]=\"size\"></ngx-avatar>\n    </ng-container>\n\n    <!-- Individual in a Group avatar -->\n    <ng-container *ngSwitchCase=\"'individual-group'\">\n        <div class=\"row fm-avatar-individual-group\">\n            <div class=\"col-auto pe-0\">\n                <ngx-avatar\n                    [name]=\"medicalGroup.name\"\n                    [src]=\"medicalGroup.avatar\"\n                    [initialsSize]=\"initialsSize\"\n                    [round]=\"false\"\n                    [cornerRadius]=\"8\"\n                    [size]=\"size\"\n                ></ngx-avatar>\n            </div>\n\n            <div class=\"col-auto ps-0\">\n                <ngx-avatar\n                    [name]=\"user.name\"\n                    [src]=\"user.avatar\"\n                    [initialsSize]=\"initialsSize\"\n                    [size]=\"size\"\n                ></ngx-avatar>\n            </div>\n        </div>\n    </ng-container>\n\n    <!-- Group avatar -->\n    <ng-container *ngSwitchCase=\"'group'\">\n        <ngx-avatar\n            [name]=\"medicalGroup.name\"\n            [src]=\"medicalGroup.avatar\"\n            [initialsSize]=\"initialsSize\"\n            [round]=\"false\"\n            [cornerRadius]=\"8\"\n            [size]=\"size\"\n        ></ngx-avatar>\n    </ng-container>\n\n    <!-- Group members avatar -->\n    <ng-container *ngSwitchCase=\"'group-members'\">\n        <div class=\"row fm-avatar-group-members\">\n            <div class=\"col-auto px-0\" *ngFor=\"let member of medicalGroup.members\">\n                <ngx-avatar\n                    [name]=\"member.name\"\n                    [src]=\"member.avatar\"\n                    [initialsSize]=\"initialsSize\"\n                    [size]=\"size\"\n                ></ngx-avatar>\n            </div>\n        </div>\n    </ng-container>\n</ng-container>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { viewMode: [{
                type: Input
            }], size: [{
                type: Input
            }], user: [{
                type: Input
            }], medicalGroup: [{
                type: Input
            }] } });

class AvatarModule {
    static forRoot(avatarConfig) {
        return {
            ngModule: AvatarModule,
            providers: [
                { provide: AVATAR_CONFIG, useValue: avatarConfig ? avatarConfig : {} }
            ]
        };
    }
}
AvatarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AvatarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AvatarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: AvatarModule, declarations: [AvatarComponent], imports: [CommonModule], exports: [AvatarComponent] });
AvatarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AvatarModule, providers: [SourceFactory, AvatarService, AvatarConfigService], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AvatarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [AvatarComponent],
                    providers: [SourceFactory, AvatarService, AvatarConfigService],
                    exports: [AvatarComponent]
                }]
        }] });

class FmAvatarModule {
}
FmAvatarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmAvatarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FmAvatarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: FmAvatarModule, declarations: [FmAvatarComponent], imports: [CommonModule, HttpClientModule, AvatarModule], exports: [FmAvatarComponent] });
FmAvatarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmAvatarModule, imports: [CommonModule, HttpClientModule, AvatarModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmAvatarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FmAvatarComponent],
                    imports: [CommonModule, HttpClientModule, AvatarModule],
                    exports: [FmAvatarComponent],
                }]
        }] });

class FmProgressComponent {
    constructor() {
        this.progress = 0;
    }
}
FmProgressComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmProgressComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FmProgressComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: FmProgressComponent, selector: "fm-progress", inputs: { progress: "progress" }, ngImport: i0, template: "<div class=\"progress-cont\">\n    <div class=\"progress\" [style.width]=\"progress + '%'\">\n    </div>\n</div>", styles: [":host .progress-cont{height:7px;width:100%;border-radius:4px;background-color:#dbdeec;position:relative}:host .progress-cont .progress{width:0;height:100%;position:absolute;z-index:1;top:0;left:0;border-radius:4px;background-color:#375fe6;transition:.5s all}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmProgressComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fm-progress', template: "<div class=\"progress-cont\">\n    <div class=\"progress\" [style.width]=\"progress + '%'\">\n    </div>\n</div>", styles: [":host .progress-cont{height:7px;width:100%;border-radius:4px;background-color:#dbdeec;position:relative}:host .progress-cont .progress{width:0;height:100%;position:absolute;z-index:1;top:0;left:0;border-radius:4px;background-color:#375fe6;transition:.5s all}\n"] }]
        }], propDecorators: { progress: [{
                type: Input
            }] } });

class FmDragAndDropDirective {
    constructor() {
        this.fileDropped = new EventEmitter();
    }
    // Dragover listener
    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = true;
    }
    // Dragleave listener
    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
    }
    // Drop listener
    ondrop(e) {
        e.preventDefault();
        e.stopPropagation();
        this.fileOver = false;
        let files = e.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
        }
    }
}
FmDragAndDropDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDragAndDropDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FmDragAndDropDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.6", type: FmDragAndDropDirective, selector: "[FmDragAndDrop]", outputs: { fileDropped: "fileDropped" }, host: { listeners: { "dragover": "onDragOver($event)", "dragleave": "onDragLeave($event)", "drop": "ondrop($event)" }, properties: { "class.fileover": "this.fileOver" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDragAndDropDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[FmDragAndDrop]'
                }]
        }], propDecorators: { fileOver: [{
                type: HostBinding,
                args: ['class.fileover']
            }], fileDropped: [{
                type: Output
            }], onDragOver: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }], onDragLeave: [{
                type: HostListener,
                args: ['dragleave', ['$event']]
            }], ondrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }] } });

class FmDragAndDropComponent {
    constructor() {
        this.onfilesUploaded = new EventEmitter();
        this.files = [];
    }
    /**
     * On file drop handler.
     *
     * @param files
     */
    onFileDropped(files) {
        this.prepareFilesList(files);
    }
    /**
     * Handle file from browsing.
     *
     * @param files List
     */
    fileBrowseHandler(e) {
        this.prepareFilesList(e?.target?.files);
    }
    /**
     * Delete file from files list.
     *
     * @param index (File index)
     */
    deleteFile(index) {
        this.files.splice(index, 1);
    }
    /**
     * Convert Files list to normal array list.
     *
     * @param files (Files List)
     */
    prepareFilesList(files) {
        for (const item of files) {
            item.progress = 0;
            this.files.push(item);
        }
        this.onfilesUploaded.emit(this.files);
    }
    /**
     * Format bytes.
     *
     * @param bytes (File size in bytes)
     * @param decimals (Decimals point)
     *
     * @returns string
     */
    formatBytes(bytes, decimals = 0) {
        if (bytes === 0) {
            return '0 Bytes';
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals || 2;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
}
FmDragAndDropComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDragAndDropComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FmDragAndDropComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: FmDragAndDropComponent, selector: "fm-drag-and-drop-input", outputs: { onfilesUploaded: "onfilesUploaded" }, ngImport: i0, template: "<div class=\"container-dnd\" FmDragAndDrop (fileDropped)=\"onFileDropped($event)\">\n\t<input\n        type=\"file\"\n        #fileDropRef\n        id=\"fileDropRef\"\n        multiple\n        (change)=\"fileBrowseHandler($event)\" />\n\t\n    <i class=\"fm-icon fm_action_export\"></i>\n\n\t<h3>Select or drag images</h3>\n\t<label for=\"fileDropRef\"></label>\n</div>\n<div class=\"files-list\">\n\t<div class=\"single-file\" *ngFor=\"let file of files; let i = index\">\n\t\t<div class=\"info\">\n\t\t\t<h4 class=\"name\">\n\t\t\t\t{{ file?.name }}\n\t\t\t</h4>\n\t\t\t<p class=\"size\">\n\t\t\t\t{{ formatBytes(file?.size) }}\n\t\t\t</p>\n\t\t\t<fm-progress [progress]=\"file?.progress\"></fm-progress>\n\t\t</div>\n\t\t<div class=\"delete\" (click)=\"deleteFile(i)\">\n\t\t\t<i class=\"fm-icon fm_control_close_circle\"></i>\n\t\t</div>\n\t</div>\n</div>\n", styles: [".container-dnd{width:100%;height:200px;padding:2rem;text-align:center;border:1px dashed #dbdeec;border-radius:8px;position:relative;margin:0 auto;display:flex;align-items:center;justify-content:center;transition:background .25s ease-out}.container-dnd:hover{background:#f9faff}.container-dnd input{cursor:pointer;opacity:0;position:absolute;z-index:2;width:100%;height:100%;top:0;left:0}.container-dnd i{margin-right:15px;color:#9397a8;font-size:1.4em}.container-dnd h3{font-size:16px;font-weight:500;color:#9397a8}.fileover{background:#f9faff}.files-list{margin-top:1.5rem;width:100%}.files-list .single-file{width:110%;padding:.5rem;justify-content:space-between;border:dashed 1px #dbdeec;border-radius:8px;margin-bottom:1rem;display:flex;flex-grow:1}.files-list .single-file .delete{display:flex;margin-left:.5rem;cursor:pointer;align-self:flex-end}.files-list .single-file .name{font-size:14px;font-weight:500;color:#353f4a;margin:0}.files-list .single-file .size{font-size:12px;font-weight:500;color:#a4a4a4;margin:0;margin-bottom:.25rem}.files-list .single-file .info{width:100%}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: FmProgressComponent, selector: "fm-progress", inputs: ["progress"] }, { kind: "directive", type: FmDragAndDropDirective, selector: "[FmDragAndDrop]", outputs: ["fileDropped"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDragAndDropComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fm-drag-and-drop-input', template: "<div class=\"container-dnd\" FmDragAndDrop (fileDropped)=\"onFileDropped($event)\">\n\t<input\n        type=\"file\"\n        #fileDropRef\n        id=\"fileDropRef\"\n        multiple\n        (change)=\"fileBrowseHandler($event)\" />\n\t\n    <i class=\"fm-icon fm_action_export\"></i>\n\n\t<h3>Select or drag images</h3>\n\t<label for=\"fileDropRef\"></label>\n</div>\n<div class=\"files-list\">\n\t<div class=\"single-file\" *ngFor=\"let file of files; let i = index\">\n\t\t<div class=\"info\">\n\t\t\t<h4 class=\"name\">\n\t\t\t\t{{ file?.name }}\n\t\t\t</h4>\n\t\t\t<p class=\"size\">\n\t\t\t\t{{ formatBytes(file?.size) }}\n\t\t\t</p>\n\t\t\t<fm-progress [progress]=\"file?.progress\"></fm-progress>\n\t\t</div>\n\t\t<div class=\"delete\" (click)=\"deleteFile(i)\">\n\t\t\t<i class=\"fm-icon fm_control_close_circle\"></i>\n\t\t</div>\n\t</div>\n</div>\n", styles: [".container-dnd{width:100%;height:200px;padding:2rem;text-align:center;border:1px dashed #dbdeec;border-radius:8px;position:relative;margin:0 auto;display:flex;align-items:center;justify-content:center;transition:background .25s ease-out}.container-dnd:hover{background:#f9faff}.container-dnd input{cursor:pointer;opacity:0;position:absolute;z-index:2;width:100%;height:100%;top:0;left:0}.container-dnd i{margin-right:15px;color:#9397a8;font-size:1.4em}.container-dnd h3{font-size:16px;font-weight:500;color:#9397a8}.fileover{background:#f9faff}.files-list{margin-top:1.5rem;width:100%}.files-list .single-file{width:110%;padding:.5rem;justify-content:space-between;border:dashed 1px #dbdeec;border-radius:8px;margin-bottom:1rem;display:flex;flex-grow:1}.files-list .single-file .delete{display:flex;margin-left:.5rem;cursor:pointer;align-self:flex-end}.files-list .single-file .name{font-size:14px;font-weight:500;color:#353f4a;margin:0}.files-list .single-file .size{font-size:12px;font-weight:500;color:#a4a4a4;margin:0;margin-bottom:.25rem}.files-list .single-file .info{width:100%}\n"] }]
        }], propDecorators: { onfilesUploaded: [{
                type: Output
            }] } });

class FmDragAndDropModule {
}
FmDragAndDropModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDragAndDropModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FmDragAndDropModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: FmDragAndDropModule, declarations: [FmDragAndDropComponent,
        FmProgressComponent,
        FmDragAndDropDirective], imports: [CommonModule], exports: [FmDragAndDropComponent,
        FmProgressComponent,
        FmDragAndDropDirective] });
FmDragAndDropModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDragAndDropModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDragAndDropModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FmDragAndDropComponent,
                        FmProgressComponent,
                        FmDragAndDropDirective,
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        FmDragAndDropComponent,
                        FmProgressComponent,
                        FmDragAndDropDirective,
                    ],
                }]
        }] });

class FmBadgeComponent {
    constructor() {
        this.color = 'default';
    }
}
FmBadgeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmBadgeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FmBadgeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: FmBadgeComponent, selector: "fm-badge", inputs: { color: "color" }, ngImport: i0, template: `<span class="{{ color }}"><ng-content></ng-content></span>`, isInline: true, styles: [":host{display:inline-block}:host span{padding:4px 8px;border-radius:4px;font-size:12px;font-style:normal;font-weight:500;line-height:16px;letter-spacing:.2px;text-align:center;white-space:nowrap}:host span.default{color:#212121;background-color:#c5cae9}:host span.primary{color:#0d47a1;background-color:#e8eaf6}:host span.information{color:#46aafe;background-color:#f0f3ff}:host span.tertiary{color:#8050ff;background-color:#f0f3ff}:host span.warning{color:#d98100;background-color:#f0f3ff}:host span.neutral{color:#3ecbff;background-color:#f0f3ff}:host span.success{color:#0d47a1;background-color:#e8eaf6}:host span.error{color:#bf360c;background-color:#ffccbc}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmBadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fm-badge', template: `<span class="{{ color }}"><ng-content></ng-content></span>`, styles: [":host{display:inline-block}:host span{padding:4px 8px;border-radius:4px;font-size:12px;font-style:normal;font-weight:500;line-height:16px;letter-spacing:.2px;text-align:center;white-space:nowrap}:host span.default{color:#212121;background-color:#c5cae9}:host span.primary{color:#0d47a1;background-color:#e8eaf6}:host span.information{color:#46aafe;background-color:#f0f3ff}:host span.tertiary{color:#8050ff;background-color:#f0f3ff}:host span.warning{color:#d98100;background-color:#f0f3ff}:host span.neutral{color:#3ecbff;background-color:#f0f3ff}:host span.success{color:#0d47a1;background-color:#e8eaf6}:host span.error{color:#bf360c;background-color:#ffccbc}\n"] }]
        }], propDecorators: { color: [{
                type: Input
            }] } });

class FmBadgeModule {
}
FmBadgeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmBadgeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FmBadgeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: FmBadgeModule, declarations: [FmBadgeComponent], imports: [CommonModule], exports: [FmBadgeComponent] });
FmBadgeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmBadgeModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmBadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FmBadgeComponent],
                    imports: [CommonModule],
                    exports: [FmBadgeComponent],
                }]
        }] });

class AwsService {
    constructor(configs, http) {
        this.configs = configs;
        this.http = http;
    }
    /**
     * Upload image.
     *
     * @param {string} bucket
     * @param {string} filePath
     * @param {string} base64
     * @param {string} visibility
     * @param {Function} successCallback
     * @param {Function} errorCallback
     * @returns void
     */
    uploadImageByBase64(bucket, filePath, visibility, base64, successCallback, errorCallback) {
        const blob = this.base64ToBlob(base64.replace(/^data:image\/(png|jpg);base64,/, ''), 'image/png');
        if (AwsService.allowedImages.includes(blob.type)) {
            this.upload(bucket, filePath, visibility, blob, successCallback, errorCallback);
        }
        else {
            errorCallback('invalid-type');
        }
    }
    /**
     * Upload image by blob.
     *
     * @param {string} bucket
     * @param {string} filePath
     * @param {Blob} blob
     * @param {string} visibility
     * @param {Function} successCallback
     * @param {Function} errorCallback
     * @returns void
     */
    uploadImageByBlob(bucket, filePath, visibility, blob, successCallback, errorCallback) {
        if (AwsService.allowedImages.includes(blob.type)) {
            this.upload(bucket, filePath, visibility, blob, successCallback, errorCallback);
        }
        else {
            errorCallback('invalid-type');
        }
    }
    /**
     * Upload document.
     *
     * @param {string} bucket
     * @param {string} filePath
     * @param {Blob} blob
     * @param {string} visibility
     * @param {Function} successCallback
     * @param {Function} errorCallback
     * @returns void
     */
    uploadBlob(bucket, filePath, visibility, blob, successCallback, errorCallback) {
        if (AwsService.allowedDocuments.includes(blob.type)) {
            this.upload(bucket, filePath, visibility, blob, successCallback, errorCallback);
        }
        else {
            errorCallback('invalid-type');
        }
    }
    /**
     * Upload to Amazon S3.
     *
     * @param {string} bucket
     * @param {string} filePath
     * @param {string} visibility
     * @param {Blob} blob
     * @param {Function} successCallback
     * @param {Function} errorCallback
     * @returns void
     */
    upload(bucket, filePath, visibility, blob, successCallback, errorCallback) {
        const fileName = this.generateFileName(filePath, blob);
        this.uploadLink(bucket, fileName)
            .pipe(take(1))
            .subscribe({
            next: (headerData) => {
                const XHR = new XMLHttpRequest();
                const amazonUrl = this.getUrlByBucket(headerData.data['BucketName']);
                XHR.addEventListener('load', function () {
                    if (XHR.status === 200 /* HttpStatusCode.Ok */ || XHR.status === 204 /* HttpStatusCode.NoContent */) {
                        successCallback(amazonUrl + fileName);
                    }
                    else {
                        errorCallback();
                    }
                });
                XHR.addEventListener('error', (event) => errorCallback(event));
                XHR.open('POST', amazonUrl);
                XHR.send(this.formData(headerData.data, blob, visibility));
            },
            error: (error) => errorCallback(error),
        });
    }
    /**
     * Generate file name.
     *
     * @param {string} filePath
     * @param {Blob} blob
     * @returns string
     */
    generateFileName(filePath, blob) {
        return `${filePath}/freddiemed_${Date.now() + Math.ceil(Math.random() * 9)}.${blob.type.split('/').pop()}`;
    }
    /**
     * Get url by bucket name.
     *
     * @param {string} bucketName
     * @returns string
     */
    getUrlByBucket(bucketName) {
        return `https://s3.eu-west-1.amazonaws.com/${bucketName}/`;
    }
    /**
     * Get FormData.
     *
     * @param {any} data - Header data from amazon (Response from uploadLink)
     * @param {any} file
     * @param {string} visibility (private|public-read)
     * @returns FormData
     */
    formData(data, file, visibility = 'private') {
        const formData = new FormData();
        formData.append('X-Amz-Date', data['X-Amz-Date']);
        formData.append('X-Amz-Algorithm', data['X-Amz-Algorithm']);
        formData.append('X-Amz-Credential', data['X-Amz-Credential']);
        formData.append('X-Amz-Signature', data['X-Amz-Signature']);
        formData.append('Policy', data['Policy']);
        formData.append('x-amz-server-side-encryption', data['x-amz-server-side-encryption']);
        formData.append('key', data['KeyPrefix']);
        formData.append('Content-Type', file.type);
        formData.append('acl', visibility);
        formData.append('file', file);
        return formData;
    }
    /**
     * Get upload link.
     *
     * @param {string} bucket
     * @param {string} fileName
     * @returns Observable<any>
     */
    uploadLink(bucket, fileName) {
        return this.http.post(`${this.configs.apiUrl}auth/get-upload-link`, { type: bucket, file_name: fileName });
    }
    /**
     * Base64 to Blob.
     *
     * @param {any} base64
     * @param {any} mime
     * @returns Blob
     */
    base64ToBlob(base64, mime) {
        mime = mime || '';
        const sliceSize = 1024;
        const byteChars = window.atob(base64);
        const byteArrays = [];
        for (let offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
            const slice = byteChars.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: mime });
    }
}
AwsService.allowedImages = ['image/jpg', 'image/jpeg', 'image/png'];
AwsService.allowedDocuments = ['application/pdf'];
AwsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AwsService, deps: [{ token: FM_CONFIGS }, { token: i1$2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
AwsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AwsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: AwsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FM_CONFIGS]
                }] }, { type: i1$2.HttpClient }]; } });

class ImageCropperDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.croppedImage = '';
        this.previewText = 'preview';
        this.buttonText = 'Finish';
        this.cropConfigs = [
            { context: 'avatar', resizeToWidth: '200', aspectRatio: '1' },
            { context: 'profile-cover', resizeToWidth: '900', aspectRatio: '3' },
            { context: 'social-cover', resizeToWidth: '1200', aspectRatio: '1.91' },
            { context: 'signature', resizeToWidth: '600', aspectRatio: '2' },
        ];
        Object.assign(this, data);
    }
    ngOnInit() {
        this._initCropConfigs();
    }
    imageCropped(event) {
        this.croppedImage = event.base64;
    }
    finish() {
        this.dialogRef.close(this.croppedImage);
    }
    close() {
        this.dialogRef.close();
    }
    _initCropConfigs() {
        const config = this.cropConfigs.find((c) => c.context === this.context);
        if (config) {
            this.aspectRatio = config.aspectRatio;
            this.resizeToWidth = config.resizeToWidth;
        }
    }
}
ImageCropperDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: ImageCropperDialogComponent, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
ImageCropperDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: ImageCropperDialogComponent, selector: "app-image-cropper-dialog", ngImport: i0, template: "<div class=\"row d-flex\">\n    <div class=\"col-10 p-0\">\n        <h3>{{ label }}</h3>\n    </div>\n    <div class=\"col d-flex justify-content-end\" (click)=\"close()\">\n        <i class=\"fm-icon fm_control_close mt-2\"></i>\n    </div>\n</div>\n\n<div class=\"fm-cropper-container\">\n    <image-cropper\n        class=\"cropper\"\n        [ngClass]=\"{ avatar: context === 'avatar' }\"\n        [imageChangedEvent]=\"imageChangedEvent\"\n        [maintainAspectRatio]=\"true\"\n        [aspectRatio]=\"aspectRatio\"\n        [resizeToWidth]=\"resizeToWidth\"\n        format=\"png\"\n        (imageCropped)=\"imageCropped($event)\">\n    </image-cropper>\n</div>\n\n<ng-container *ngIf=\"hasPreview\">\n    <div class=\"col-12 my-3 p-0\">\n        <strong>{{ previewText }}</strong>\n    </div>\n    <div class=\"col-12 mb-3 p-0\">\n        <img\n            class=\"preview\"\n            alt=\"preview\"\n            [ngClass]=\"{ avatar: context === 'avatar' }\"\n            [src]=\"croppedImage\" />\n    </div>\n</ng-container>\n\n<div class=\"row d-flex justify-content-end\">\n    <button\n        mat-button\n        class=\"fm-primary\"\n        (click)=\"finish()\">\n        {{ buttonText }}\n    </button>\n</div>\n", styles: [":host h3{margin-top:10px}:host i{cursor:pointer}:host .cropper.avatar{max-height:380px;max-width:380px}:host .preview.avatar{border-radius:50%}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.ImageCropperComponent, selector: "image-cropper", inputs: ["imageChangedEvent", "imageURL", "imageBase64", "imageFile", "format", "transform", "maintainAspectRatio", "aspectRatio", "resizeToWidth", "resizeToHeight", "cropperMinWidth", "cropperMinHeight", "cropperMaxHeight", "cropperMaxWidth", "cropperStaticWidth", "cropperStaticHeight", "canvasRotation", "initialStepSize", "roundCropper", "onlyScaleDown", "imageQuality", "autoCrop", "backgroundColor", "containWithinAspectRatio", "hideResizeSquares", "cropper", "alignImage", "disabled"], outputs: ["imageCropped", "startCropImage", "imageLoaded", "cropperReady", "loadImageFailed"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: ImageCropperDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-image-cropper-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row d-flex\">\n    <div class=\"col-10 p-0\">\n        <h3>{{ label }}</h3>\n    </div>\n    <div class=\"col d-flex justify-content-end\" (click)=\"close()\">\n        <i class=\"fm-icon fm_control_close mt-2\"></i>\n    </div>\n</div>\n\n<div class=\"fm-cropper-container\">\n    <image-cropper\n        class=\"cropper\"\n        [ngClass]=\"{ avatar: context === 'avatar' }\"\n        [imageChangedEvent]=\"imageChangedEvent\"\n        [maintainAspectRatio]=\"true\"\n        [aspectRatio]=\"aspectRatio\"\n        [resizeToWidth]=\"resizeToWidth\"\n        format=\"png\"\n        (imageCropped)=\"imageCropped($event)\">\n    </image-cropper>\n</div>\n\n<ng-container *ngIf=\"hasPreview\">\n    <div class=\"col-12 my-3 p-0\">\n        <strong>{{ previewText }}</strong>\n    </div>\n    <div class=\"col-12 mb-3 p-0\">\n        <img\n            class=\"preview\"\n            alt=\"preview\"\n            [ngClass]=\"{ avatar: context === 'avatar' }\"\n            [src]=\"croppedImage\" />\n    </div>\n</ng-container>\n\n<div class=\"row d-flex justify-content-end\">\n    <button\n        mat-button\n        class=\"fm-primary\"\n        (click)=\"finish()\">\n        {{ buttonText }}\n    </button>\n</div>\n", styles: [":host h3{margin-top:10px}:host i{cursor:pointer}:host .cropper.avatar{max-height:380px;max-width:380px}:host .preview.avatar{border-radius:50%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

class FmUploaderComponent {
    constructor(matDialog, awsService) {
        this.matDialog = matDialog;
        this.awsService = awsService;
        this.useCropper = '';
        this.hasPreview = false;
        this.awsVisibility = 'private';
        this.previewText = 'preview';
        this.buttonText = 'finish';
        this.success = new EventEmitter();
        this.error = new EventEmitter();
        this.randomId = Math.random();
    }
    ngOnInit() {
        this.acceptedTypes =
            this.fileType === 'image' ? AwsService.allowedImages.join(',') : AwsService.allowedDocuments.join(',');
    }
    uploadFile(event) {
        if (event.target.files.length === 0) {
            return;
        }
        if (this.fileType === 'image') {
            if (this.useCropper) {
                this._uploadImageUsingCropper(event);
            }
            else if (event.srcElement.files.length) {
                this._uploadImage(event.srcElement.files[0]);
            }
        }
        else if (event.srcElement.files.length) {
            this._uploadDocument(event.srcElement.files[0]);
        }
    }
    /**
     * Crop the image and then upload it to the S3.
     *
     * @param {any} event
     * @returns void
     */
    _uploadImageUsingCropper(event) {
        const dialog = this.matDialog.open(ImageCropperDialogComponent, {
            maxHeight: '90vh',
            data: {
                label: this.label,
                imageChangedEvent: event,
                context: this.useCropper,
                hasPreview: this.hasPreview,
                previewText: this.previewText,
                buttonText: this.buttonText,
            },
        });
        dialog.afterClosed().subscribe((base64) => {
            if (base64) {
                this.awsService.uploadImageByBase64(this.awsBucket, this.awsFilePath, this.awsVisibility, base64, (event) => this.success.emit(event), (event) => this.error.emit(event));
            }
        });
    }
    /**
     * Upload image to S3.
     *
     * @param {Blob} blob
     * @returns void
     */
    _uploadImage(blob) {
        this.awsService.uploadImageByBlob(this.awsBucket, this.awsFilePath, this.awsVisibility, blob, (event) => this.success.emit(event), (event) => this.error.emit(event));
    }
    /**
     * Upload a document (blob) to S3.
     *
     * @param {Blob} blob
     * @returns void
     */
    _uploadDocument(blob) {
        this.awsService.uploadBlob(this.awsBucket, this.awsFilePath, this.awsVisibility, blob, (event) => this.success.emit(event), (event) => this.error.emit(event));
    }
}
FmUploaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmUploaderComponent, deps: [{ token: i1$1.MatDialog }, { token: AwsService }], target: i0.ɵɵFactoryTarget.Component });
FmUploaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: FmUploaderComponent, selector: "fm-uploader", inputs: { fileType: "fileType", useCropper: "useCropper", hasPreview: "hasPreview", label: "label", awsBucket: "awsBucket", awsFilePath: "awsFilePath", awsVisibility: "awsVisibility", previewText: "previewText", buttonText: "buttonText" }, outputs: { success: "success", error: "error" }, ngImport: i0, template: "<span class=\"upload\">\n    <input\n        type=\"file\"\n        [id]=\"randomId\"\n        [accept]=\"acceptedTypes\"\n        [hidden]=\"true\"\n        (change)=\"uploadFile($event)\" />\n    <label [for]=\"randomId\">\n        {{ label ?? 'Upload' }}\n        <fm-icon class=\"pl-3\" [name]=\"'fm_action_export'\"></fm-icon>\n    </label>\n</span>\n", styles: [":host{cursor:pointer;transition:opacity .2s ease-in}:host:hover{opacity:.8}\n"], dependencies: [{ kind: "component", type: FmIconComponent, selector: "fm-icon", inputs: ["name", "color"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmUploaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fm-uploader', changeDetection: ChangeDetectionStrategy.OnPush, template: "<span class=\"upload\">\n    <input\n        type=\"file\"\n        [id]=\"randomId\"\n        [accept]=\"acceptedTypes\"\n        [hidden]=\"true\"\n        (change)=\"uploadFile($event)\" />\n    <label [for]=\"randomId\">\n        {{ label ?? 'Upload' }}\n        <fm-icon class=\"pl-3\" [name]=\"'fm_action_export'\"></fm-icon>\n    </label>\n</span>\n", styles: [":host{cursor:pointer;transition:opacity .2s ease-in}:host:hover{opacity:.8}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: AwsService }]; }, propDecorators: { fileType: [{
                type: Input
            }], useCropper: [{
                type: Input
            }], hasPreview: [{
                type: Input
            }], label: [{
                type: Input
            }], awsBucket: [{
                type: Input
            }], awsFilePath: [{
                type: Input
            }], awsVisibility: [{
                type: Input
            }], previewText: [{
                type: Input
            }], buttonText: [{
                type: Input
            }], success: [{
                type: Output
            }], error: [{
                type: Output
            }] } });

class FmUploaderModule {
}
FmUploaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmUploaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FmUploaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: FmUploaderModule, declarations: [FmUploaderComponent, ImageCropperDialogComponent], imports: [CommonModule, ImageCropperModule, MatButtonModule, FmIconModule], exports: [FmUploaderComponent] });
FmUploaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmUploaderModule, imports: [CommonModule, ImageCropperModule, MatButtonModule, FmIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmUploaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FmUploaderComponent, ImageCropperDialogComponent],
                    imports: [CommonModule, ImageCropperModule, MatButtonModule, FmIconModule],
                    exports: [FmUploaderComponent]
                }]
        }] });

class CountryCode {
    constructor() {
        this.allCountries = [
            ['Afghanistan (‫افغانستان‬‎)', 'af', '93'],
            ['Albania (Shqipëri)', 'al', '355'],
            ['Algeria (‫الجزائر‬‎)', 'dz', '213'],
            ['American Samoa', 'as', '1684'],
            ['Andorra', 'ad', '376'],
            ['Angola', 'ao', '244'],
            ['Anguilla', 'ai', '1264'],
            ['Antigua and Barbuda', 'ag', '1268'],
            ['Argentina', 'ar', '54'],
            ['Armenia (Հայաստան)', 'am', '374'],
            ['Aruba', 'aw', '297'],
            ['Australia', 'au', '61', 0],
            ['Austria (Österreich)', 'at', '43'],
            ['Azerbaijan (Azərbaycan)', 'az', '994'],
            ['Bahamas', 'bs', '1242'],
            ['Bahrain (‫البحرين‬‎)', 'bh', '973'],
            ['Bangladesh (বাংলাদেশ)', 'bd', '880'],
            ['Barbados', 'bb', '1246'],
            ['Belarus (Беларусь)', 'by', '375'],
            ['Belgium (België)', 'be', '32'],
            ['Belize', 'bz', '501'],
            ['Benin (Bénin)', 'bj', '229'],
            ['Bermuda', 'bm', '1441'],
            ['Bhutan (འབྲུག)', 'bt', '975'],
            ['Bolivia', 'bo', '591'],
            ['Bosnia and Herzegovina (Босна и Херцеговина)', 'ba', '387'],
            ['Botswana', 'bw', '267'],
            ['Brazil (Brasil)', 'br', '55'],
            ['British Indian Ocean Territory', 'io', '246'],
            ['British Virgin Islands', 'vg', '1284'],
            ['Brunei', 'bn', '673'],
            ['Bulgaria (България)', 'bg', '359'],
            ['Burkina Faso', 'bf', '226'],
            ['Burundi (Uburundi)', 'bi', '257'],
            ['Cambodia (កម្ពុជា)', 'kh', '855'],
            ['Cameroon (Cameroun)', 'cm', '237'],
            ['Canada', 'ca', '1', 1, ['204', '226', '236', '249', '250', '289', '306', '343', '365', '387', '403', '416', '418', '431', '437',
                    '438', '450', '506', '514', '519', '548', '579', '581', '587', '604', '613', '639', '647', '672', '705', '709', '742',
                    '778', '780', '782', '807', '819', '825', '867', '873', '902', '905']],
            ['Cape Verde (Kabu Verdi)', 'cv', '238'],
            ['Caribbean Netherlands', 'bq', '599', 1],
            ['Cayman Islands', 'ky', '1345'],
            ['Central African Republic (République centrafricaine)', 'cf', '236'],
            ['Chad (Tchad)', 'td', '235'],
            ['Chile', 'cl', '56'],
            ['China (中国)', 'cn', '86'],
            ['Christmas Island', 'cx', '61', 2],
            ['Cocos (Keeling) Islands', 'cc', '61', 1],
            ['Colombia', 'co', '57'],
            ['Comoros (‫جزر القمر‬‎)', 'km', '269'],
            ['Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', 'cd', '243'],
            ['Congo (Republic) (Congo-Brazzaville)', 'cg', '242'],
            ['Cook Islands', 'ck', '682'],
            ['Costa Rica', 'cr', '506'],
            ['Côte d’Ivoire', 'ci', '225'],
            ['Croatia (Hrvatska)', 'hr', '385'],
            ['Cuba', 'cu', '53'],
            ['Curaçao', 'cw', '599', 0],
            ['Cyprus (Κύπρος)', 'cy', '357'],
            ['Czech Republic (Česká republika)', 'cz', '420'],
            ['Denmark (Danmark)', 'dk', '45'],
            ['Djibouti', 'dj', '253'],
            ['Dominica', 'dm', '1767'],
            ['Dominican Republic (República Dominicana)', 'do', '1', 2, ['809', '829', '849']], ['Ecuador', 'ec', '593'],
            ['Egypt (‫مصر‬‎)', 'eg', '20'],
            ['El Salvador', 'sv', '503'],
            ['Equatorial Guinea (Guinea Ecuatorial)', 'gq', '240'],
            ['Eritrea', 'er', '291'],
            ['Estonia (Eesti)', 'ee', '372'],
            ['Ethiopia', 'et', '251'],
            ['Falkland Islands (Islas Malvinas)', 'fk', '500'],
            ['Faroe Islands (Føroyar)', 'fo', '298'],
            ['Fiji', 'fj', '679'],
            ['Finland (Suomi)', 'fi', '358', 0],
            ['France', 'fr', '33'],
            ['French Guiana (Guyane française)', 'gf', '594'],
            ['French Polynesia (Polynésie française)', 'pf', '689'],
            ['Gabon', 'ga', '241'],
            ['Gambia', 'gm', '220'],
            ['Georgia (საქართველო)', 'ge', '995'],
            ['Germany (Deutschland)', 'de', '49'],
            ['Ghana (Gaana)', 'gh', '233'],
            ['Gibraltar', 'gi', '350'],
            ['Greece (Ελλάδα)', 'gr', '30'],
            ['Greenland (Kalaallit Nunaat)', 'gl', '299'],
            ['Grenada', 'gd', '1473'],
            ['Guadeloupe', 'gp', '590', 0],
            ['Guam', 'gu', '1671'],
            ['Guatemala', 'gt', '502'],
            ['Guernsey', 'gg', '44', 1],
            ['Guinea (Guinée)', 'gn', '224'],
            ['Guinea-Bissau (Guiné Bissau)', 'gw', '245'],
            ['Guyana', 'gy', '592'],
            ['Haiti', 'ht', '509'],
            ['Honduras', 'hn', '504'],
            ['Hong Kong (香港)', 'hk', '852'],
            ['Hungary (Magyarország)', 'hu', '36'],
            ['Iceland (Ísland)', 'is', '354'],
            ['India (भारत)', 'in', '91'],
            ['Indonesia', 'id', '62'],
            ['Iran (‫ایران‬‎)', 'ir', '98'],
            ['Iraq (‫العراق‬‎)', 'iq', '964'],
            ['Ireland', 'ie', '353'],
            ['Isle of Man', 'im', '44', 2],
            ['Israel (‫ישראל‬‎)', 'il', '972'],
            ['Italy (Italia)', 'it', '39', 0],
            ['Jamaica', 'jm', '1', 4, ['876', '658']], ['Japan (日本)', 'jp', '81'],
            ['Jersey', 'je', '44', 3],
            ['Jordan (‫الأردن‬‎)', 'jo', '962'],
            ['Kazakhstan (Казахстан)', 'kz', '7', 1],
            ['Kenya', 'ke', '254'],
            ['Kiribati', 'ki', '686'],
            ['Kosovo', 'xk', '383'],
            ['Kuwait (‫الكويت‬‎)', 'kw', '965'],
            ['Kyrgyzstan (Кыргызстан)', 'kg', '996'],
            ['Laos (ລາວ)', 'la', '856'],
            ['Latvia (Latvija)', 'lv', '371'],
            ['Lebanon (‫لبنان‬‎)', 'lb', '961'],
            ['Lesotho', 'ls', '266'],
            ['Liberia', 'lr', '231'],
            ['Libya (‫ليبيا‬‎)', 'ly', '218'],
            ['Liechtenstein', 'li', '423'],
            ['Lithuania (Lietuva)', 'lt', '370'],
            ['Luxembourg', 'lu', '352'],
            ['Macau (澳門)', 'mo', '853'],
            ['Macedonia (FYROM) (Македонија)', 'mk', '389'],
            ['Madagascar (Madagasikara)', 'mg', '261'],
            ['Malawi', 'mw', '265'],
            ['Malaysia', 'my', '60'],
            ['Maldives', 'mv', '960'],
            ['Mali', 'ml', '223'],
            ['Malta', 'mt', '356'],
            ['Marshall Islands', 'mh', '692'],
            ['Martinique', 'mq', '596'],
            ['Mauritania (‫موريتانيا‬‎)', 'mr', '222'],
            ['Mauritius (Moris)', 'mu', '230'],
            ['Mayotte', 'yt', '262', 1],
            ['Mexico (México)', 'mx', '52'],
            ['Micronesia', 'fm', '691'],
            ['Moldova (Republica Moldova)', 'md', '373'],
            ['Monaco', 'mc', '377'],
            ['Mongolia (Монгол)', 'mn', '976'],
            ['Montenegro (Crna Gora)', 'me', '382'],
            ['Montserrat', 'ms', '1664'],
            ['Morocco (‫المغرب‬‎)', 'ma', '212', 0],
            ['Mozambique (Moçambique)', 'mz', '258'],
            ['Myanmar (Burma) (မြန်မာ)', 'mm', '95'],
            ['Namibia (Namibië)', 'na', '264'],
            ['Nauru', 'nr', '674'],
            ['Nepal (नेपाल)', 'np', '977'],
            ['Netherlands (Nederland)', 'nl', '31'],
            ['New Caledonia (Nouvelle-Calédonie)', 'nc', '687'],
            ['New Zealand', 'nz', '64'],
            ['Nicaragua', 'ni', '505'],
            ['Niger (Nijar)', 'ne', '227'],
            ['Nigeria', 'ng', '234'],
            ['Niue', 'nu', '683'],
            ['Norfolk Island', 'nf', '672'],
            ['North Korea (조선 민주주의 인민 공화국)', 'kp', '850'],
            ['Northern Mariana Islands', 'mp', '1670'],
            ['Norway (Norge)', 'no', '47', 0],
            ['Oman (‫عُمان‬‎)', 'om', '968'],
            ['Pakistan (‫پاکستان‬‎)', 'pk', '92'],
            ['Palau', 'pw', '680'],
            ['Palestine (‫فلسطين‬‎)', 'ps', '970'],
            ['Panama (Panamá)', 'pa', '507'],
            ['Papua New Guinea', 'pg', '675'],
            ['Paraguay', 'py', '595'],
            ['Peru (Perú)', 'pe', '51'],
            ['Philippines', 'ph', '63'],
            ['Poland (Polska)', 'pl', '48'],
            ['Portugal', 'pt', '351'],
            ['Puerto Rico', 'pr', '1', 3, ['787', '939']], ['Qatar (‫قطر‬‎)', 'qa', '974'],
            ['Réunion (La Réunion)', 're', '262', 0],
            ['Romania (România)', 'ro', '40'],
            ['Russia (Россия)', 'ru', '7', 0],
            ['Rwanda', 'rw', '250'],
            ['Saint Barthélemy', 'bl', '590', 1],
            ['Saint Helena', 'sh', '290'],
            ['Saint Kitts and Nevis', 'kn', '1869'],
            ['Saint Lucia', 'lc', '1758'],
            ['Saint Martin (Saint-Martin (partie française))', 'mf', '590', 2],
            ['Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)', 'pm', '508'],
            ['Saint Vincent and the Grenadines', 'vc', '1784'],
            ['Samoa', 'ws', '685'],
            ['San Marino', 'sm', '378'],
            ['São Tomé and Príncipe (São Tomé e Príncipe)', 'st', '239'],
            ['Saudi Arabia (‫المملكة العربية السعودية‬‎)', 'sa', '966'],
            ['Senegal (Sénégal)', 'sn', '221'],
            ['Serbia (Србија)', 'rs', '381'],
            ['Seychelles', 'sc', '248'],
            ['Sierra Leone', 'sl', '232'],
            ['Singapore', 'sg', '65'],
            ['Sint Maarten', 'sx', '1721'],
            ['Slovakia (Slovensko)', 'sk', '421'],
            ['Slovenia (Slovenija)', 'si', '386'],
            ['Solomon Islands', 'sb', '677'],
            ['Somalia (Soomaaliya)', 'so', '252'],
            ['South Africa', 'za', '27'],
            ['South Korea (대한민국)', 'kr', '82'],
            ['South Sudan (‫جنوب السودان‬‎)', 'ss', '211'],
            ['Spain (España)', 'es', '34'],
            ['Sri Lanka (ශ්‍රී ලංකාව)', 'lk', '94'],
            ['Sudan (‫السودان‬‎)', 'sd', '249'],
            ['Suriname', 'sr', '597'],
            ['Svalbard and Jan Mayen', 'sj', '47', 1],
            ['Swaziland', 'sz', '268'],
            ['Sweden (Sverige)', 'se', '46'],
            ['Switzerland (Schweiz)', 'ch', '41'],
            ['Syria (‫سوريا‬‎)', 'sy', '963'],
            ['Taiwan (台灣)', 'tw', '886'],
            ['Tajikistan', 'tj', '992'],
            ['Tanzania', 'tz', '255'],
            ['Thailand (ไทย)', 'th', '66'],
            ['Timor-Leste', 'tl', '670'],
            ['Togo', 'tg', '228'],
            ['Tokelau', 'tk', '690'],
            ['Tonga', 'to', '676'],
            ['Trinidad and Tobago', 'tt', '1868'],
            ['Tunisia (‫تونس‬‎)', 'tn', '216'],
            ['Turkey (Türkiye)', 'tr', '90'],
            ['Turkmenistan', 'tm', '993'],
            ['Turks and Caicos Islands', 'tc', '1649'],
            ['Tuvalu', 'tv', '688'],
            ['U.S. Virgin Islands', 'vi', '1340'],
            ['Uganda', 'ug', '256'],
            ['Ukraine (Україна)', 'ua', '380'],
            ['United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', 'ae', '971'],
            ['United Kingdom', 'gb', '44', 0],
            ['United States', 'us', '1', 0],
            ['Uruguay', 'uy', '598'],
            ['Uzbekistan (Oʻzbekiston)', 'uz', '998'],
            ['Vanuatu', 'vu', '678'],
            ['Vatican City (Città del Vaticano)', 'va', '39', 1],
            ['Venezuela', 've', '58'],
            ['Vietnam (Việt Nam)', 'vn', '84'],
            ['Wallis and Futuna (Wallis-et-Futuna)', 'wf', '681'],
            ['Western Sahara (‫الصحراء الغربية‬‎)', 'eh', '212', 1],
            ['Yemen (‫اليمن‬‎)', 'ye', '967'],
            ['Zambia', 'zm', '260'],
            ['Zimbabwe', 'zw', '263'],
            ['Åland Islands', 'ax', '358', 1]
        ];
    }
}
CountryCode.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: CountryCode, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
CountryCode.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: CountryCode });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: CountryCode, decorators: [{
            type: Injectable
        }] });
const Examples = {
    '001': '001',
    AC: '40123',
    AD: '312345',
    AE: '501234567',
    AF: '701234567',
    AG: '2684641234',
    AI: '2642351234',
    AL: '662123456',
    AM: '77123456',
    AO: '923123456',
    AR: '91123456789',
    AS: '6847331234',
    AT: '664123456',
    AU: '412345678',
    AW: '5601234',
    AX: '412345678',
    AZ: '401234567',
    BA: '61123456',
    BB: '2462501234',
    BD: '1812345678',
    BE: '470123456',
    BF: '70123456',
    BG: '48123456',
    BH: '36001234',
    BI: '79561234',
    BJ: '90011234',
    BL: '690001234',
    BM: '4413701234',
    BN: '7123456',
    BO: '71234567',
    BQ: '3181234',
    BR: '11961234567',
    BS: '2423591234',
    BT: '17123456',
    BW: '71123456',
    BY: '294911911',
    BZ: '6221234',
    CA: '5062345678',
    CC: '412345678',
    CD: '991234567',
    CF: '70012345',
    CG: '061234567',
    CH: '781234567',
    CI: '01234567',
    CK: '71234',
    CL: '221234567',
    CM: '671234567',
    CN: '13123456789',
    CO: '3211234567',
    CR: '83123456',
    CU: '51234567',
    CV: '9911234',
    CW: '95181234',
    CX: '412345678',
    CY: '96123456',
    CZ: '601123456',
    DE: '15123456789',
    DJ: '77831001',
    DK: '32123456',
    DM: '7672251234',
    DO: '8092345678',
    DZ: '551234567',
    EC: '991234567',
    EE: '51234567',
    EG: '1001234567',
    EH: '650123456',
    ER: '7123456',
    ES: '612345678',
    ET: '911234567',
    FI: '412345678',
    FJ: '7012345',
    FK: '51234',
    FM: '3501234',
    FO: '211234',
    FR: '612345678',
    GA: '06031234',
    GB: '7400123456',
    GD: '4734031234',
    GE: '555123456',
    GF: '694201234',
    GG: '7781123456',
    GH: '231234567',
    GI: '57123456',
    GL: '221234',
    GM: '3012345',
    GN: '601123456',
    GP: '690001234',
    GQ: '222123456',
    GR: '6912345678',
    GT: '51234567',
    GU: '6713001234',
    GW: '955012345',
    GY: '6091234',
    HK: '51234567',
    HN: '91234567',
    HR: '921234567',
    HT: '34101234',
    HU: '201234567',
    ID: '812345678',
    IE: '850123456',
    IL: '502345678',
    IM: '7924123456',
    IN: '8123456789',
    IO: '3801234',
    IQ: '7912345678',
    IR: '9123456789',
    IS: '6111234',
    IT: '3123456789',
    JE: '7797712345',
    JM: '8762101234',
    JO: '790123456',
    JP: '9012345678',
    KE: '712123456',
    KG: '700123456',
    KH: '91234567',
    KI: '72001234',
    KM: '3212345',
    KN: '8697652917',
    KP: '1921234567',
    KR: '1000000000',
    KW: '50012345',
    KY: '3453231234',
    KZ: '7710009998',
    LA: '2023123456',
    LB: '71123456',
    LC: '7582845678',
    LI: '660234567',
    LK: '712345678',
    LR: '770123456',
    LS: '50123456',
    LT: '61234567',
    LU: '628123456',
    LV: '21234567',
    LY: '912345678',
    MA: '650123456',
    MC: '612345678',
    MD: '62112345',
    ME: '67622901',
    MF: '690001234',
    MG: '321234567',
    MH: '2351234',
    MK: '72345678',
    ML: '65012345',
    MM: '92123456',
    MN: '88123456',
    MO: '66123456',
    MP: '6702345678',
    MQ: '696201234',
    MR: '22123456',
    MS: '6644923456',
    MT: '96961234',
    MU: '52512345',
    MV: '7712345',
    MW: '991234567',
    MX: '12221234567',
    MY: '123456789',
    MZ: '821234567',
    NA: '811234567',
    NC: '751234',
    NE: '93123456',
    NF: '381234',
    NG: '8021234567',
    NI: '81234567',
    NL: '612345678',
    NO: '40612345',
    NP: '9841234567',
    NR: '5551234',
    NU: '8884012',
    NZ: '211234567',
    OM: '92123456',
    PA: '61234567',
    PE: '912345678',
    PF: '87123456',
    PG: '70123456',
    PH: '9051234567',
    PK: '3012345678',
    PL: '512345678',
    PM: '551234',
    PR: '7872345678',
    PS: '599123456',
    PT: '912345678',
    PW: '6201234',
    PY: '961456789',
    QA: '33123456',
    RE: '692123456',
    RO: '712034567',
    RS: '601234567',
    RU: '9123456789',
    RW: '720123456',
    SA: '512345678',
    SB: '7421234',
    SC: '2510123',
    SD: '911231234',
    SE: '701234567',
    SG: '81234567',
    SH: '51234',
    SI: '31234567',
    SJ: '41234567',
    SK: '912123456',
    SL: '25123456',
    SM: '66661212',
    SN: '701234567',
    SO: '71123456',
    SR: '7412345',
    SS: '977123456',
    ST: '9812345',
    SV: '70123456',
    SX: '7215205678',
    SY: '944567890',
    SZ: '76123456',
    TA: '8999',
    TC: '6492311234',
    TD: '63012345',
    TG: '90112345',
    TH: '812345678',
    TJ: '917123456',
    TK: '7290',
    TL: '77212345',
    TM: '66123456',
    TN: '20123456',
    TO: '7715123',
    TR: '5012345678',
    TT: '8682911234',
    TV: '901234',
    TW: '912345678',
    TZ: '621234567',
    UA: '501234567',
    UG: '712345678',
    US: '2015550123',
    UY: '94231234',
    UZ: '912345678',
    VA: '3123456789',
    VC: '7844301234',
    VE: '4121234567',
    VG: '2843001234',
    VI: '3406421234',
    VN: '912345678',
    VU: '5912345',
    WF: '501234',
    WS: '7212345',
    XK: '43201234',
    YE: '712345678',
    YT: '639012345',
    ZA: '711234567',
    ZM: '955123456',
    ZW: '712345678'
};

class SearchPipe {
    transform(country, query) {
        if (!query || query === '') {
            return true;
        }
        return country.toLowerCase().includes(query.toLowerCase());
    }
}
SearchPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: SearchPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SearchPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: SearchPipe, name: "search" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: SearchPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'search',
                }]
        }] });

class LacMatCountrySelectorComponent {
    constructor(countryCodeData) {
        this.countryCodeData = countryCodeData;
        this.preferredCountries = [];
        this.onlyCountries = [];
        this.searchPlaceholder = '';
        this.change = new EventEmitter();
        this.allCountries = [];
        this.preferredCountriesInDropDown = [];
        this.fetchCountryData();
    }
    get disabled() {
        return this.selectorFor && this.selectorFor.disabled;
    }
    // builds the All Countries array
    fetchCountryData() {
        this.countryCodeData.allCountries.forEach((c) => {
            const country = {
                name: c[0].toString(),
                iso2: c[1].toString(),
                dialCode: c[2].toString(),
                priority: +c[3] || 0,
                areaCodes: c[4] || undefined,
                flagClass: c[1].toString().toUpperCase(),
                placeHolder: '',
            };
            this.allCountries.push(country);
        });
    }
    ngOnInit() {
        // build preferred countries arrays if they are specified
        if (this.preferredCountries.length) {
            this.preferredCountries.forEach((iso2) => {
                const preferredCountry = this.allCountries.filter((c) => {
                    return c.iso2 === iso2;
                });
                this.preferredCountriesInDropDown.push(preferredCountry[0]);
            });
        }
        // filter countries if required
        if (this.onlyCountries.length) {
            this.allCountries = this.allCountries.filter((c) => this.onlyCountries.includes(c.iso2));
        }
        // set the default selected a country
        let defaultCountry;
        if (this.preferredCountriesInDropDown.length) {
            defaultCountry = this.preferredCountriesInDropDown[0];
        }
        else {
            defaultCountry = this.allCountries[0];
        }
        if (this.selectorFor) {
            this.countrySubscription = this.selectorFor.countryChange.subscribe((c) => this.onCountryUpdateFromInput(c));
        }
        this.selectCountry(defaultCountry);
    }
    ngOnDestroy() {
        if (this.countrySubscription) {
            this.countrySubscription.unsubscribe();
        }
    }
    selectCountry(country) {
        this.selectedCountry = country;
        if (this.selectorFor) {
            this.selectorFor.onCountrySelected(country.flagClass);
        }
        this.change.next(country);
    }
    onCountryUpdateFromInput(code) {
        let country = this.allCountries.find((c) => {
            return c.flagClass === code.toString();
        });
        this.selectedCountry = country;
        this.change.next(country);
    }
    onOpenMenuClick() {
        if (!this.disableSearch && this.searchInput) {
            setTimeout(() => this.searchInput.focus());
        }
    }
    onMenuClosed() {
        this.searchQuery = '';
    }
}
LacMatCountrySelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: LacMatCountrySelectorComponent, deps: [{ token: CountryCode }], target: i0.ɵɵFactoryTarget.Component });
LacMatCountrySelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: LacMatCountrySelectorComponent, selector: "lac-mat-country-selector", inputs: { selectorFor: "selectorFor", preferredCountries: "preferredCountries", onlyCountries: "onlyCountries", showDialCode: "showDialCode", disableSearch: "disableSearch", searchPlaceholder: "searchPlaceholder" }, outputs: { change: "change" }, providers: [CountryCode], viewQueries: [{ propertyName: "searchInput", first: true, predicate: ["searchInput"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"selectedCountry\">\n  <button\n    class=\"country-selector\"\n    type=\"button\"\n    mat-button\n    [matMenuTriggerFor]=\"menu\"\n    [disabled]=\"disabled\"\n    (click)=\"onOpenMenuClick()\">\n    <span class=\"country-selector-flag flag\" [ngClass]=\"selectedCountry.flagClass\"></span>\n    <span class=\"country-selector-code\" [hidden]=\"!showDialCode\">+{{ selectedCountry.dialCode }}</span>\n    <span class=\"country-arrow\"></span>\n  </button>\n  <mat-menu #menu=\"matMenu\" (closed)=\"onMenuClosed()\">\n    <div class=\"country-search-container\">\n      <mat-form-field class=\"country-search\" *ngIf=\"!disableSearch\" appearance=\"outline\" (click)=\"$event.stopPropagation()\">\n        <input\n          matInput\n          [(ngModel)]=\"searchQuery\"\n          type=\"text\"\n          [placeholder]=\"searchPlaceholder\"\n          #searchInput=\"matInput\"/>\n      </mat-form-field>\n    </div>\n    \n    <button type=\"button\" mat-menu-item class=\"country-list-button\" *ngFor=\"let country of preferredCountriesInDropDown\" (click)=\"selectCountry(country)\">\n      <div class=\"icon-wrapper\">\n        <div class=\"flag\" [ngClass]=\"country.flagClass\"></div>\n      </div>\n      <div class=\"label-wrapper\">{{country.name}} +{{country.dialCode}}</div>\n    </button>\n    <mat-divider *ngIf=\"preferredCountriesInDropDown?.length\"></mat-divider>\n    \n    <ng-container *ngFor=\"let country of allCountries\">\n      <button type=\"button\" mat-menu-item class=\"country-list-button\" *ngIf=\"country.name | search:searchQuery\" (click)=\"selectCountry(country)\">\n        <div class=\"icon-wrapper\">\n          <div class=\"flag\" [ngClass]=\"country.flagClass\"></div>\n        </div>\n        <div class=\"label-wrapper\">{{country.name}} +{{country.dialCode}}</div>\n      </button>\n    </ng-container>\n  </mat-menu>\n</ng-container>", styles: [".flag{background-image:url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/flags_sprite_2x.png);background-size:100% auto;filter:drop-shadow(1px 1px 1px rgba(0,0,0,.54));height:14px;width:24px}.country-selector-flag{display:inline-block;margin-right:5px}.country-selector-code{margin-right:5px;font-size:initial;font-weight:initial}.icon-wrapper,.label-wrapper{display:table-cell;vertical-align:middle}.icon-wrapper{padding-right:15px}.country-arrow{width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid;margin:0 4px;color:#0000008a;display:table-cell;vertical-align:middle}.country-search-container{padding:10px}.mat-form-field.country-search{width:100%}.mat-form-field.country-search .mat-form-field-infix{padding:0 0 10px}.mat-form-field.country-search .mat-form-field-wrapper{padding-bottom:0}.flag.KY{background-position:0 0}.flag.AC{background-position:0 -14px}.flag.AE{background-position:0 -28px}.flag.AF{background-position:0 -42px}.flag.AG{background-position:0 -56px}.flag.AI{background-position:0 -70px}.flag.AL{background-position:0 -84px}.flag.AM{background-position:0 -98px}.flag.AO{background-position:0 -112px}.flag.AQ{background-position:0 -126px}.flag.AR{background-position:0 -140px}.flag.AS{background-position:0 -154px}.flag.AT{background-position:0 -168px}.flag.AU{background-position:0 -182px}.flag.AW{background-position:0 -196px}.flag.AX{background-position:0 -210px}.flag.AZ{background-position:0 -224px}.flag.BA{background-position:0 -238px}.flag.BB{background-position:0 -252px}.flag.BD{background-position:0 -266px}.flag.BE{background-position:0 -280px}.flag.BF{background-position:0 -294px}.flag.BG{background-position:0 -308px}.flag.BH{background-position:0 -322px}.flag.BI{background-position:0 -336px}.flag.BJ{background-position:0 -350px}.flag.BL{background-position:0 -364px}.flag.BM{background-position:0 -378px}.flag.BN{background-position:0 -392px}.flag.BO{background-position:0 -406px}.flag.BQ{background-position:0 -420px}.flag.BR{background-position:0 -434px}.flag.BS{background-position:0 -448px}.flag.BT{background-position:0 -462px}.flag.BV{background-position:0 -476px}.flag.BW{background-position:0 -490px}.flag.BY{background-position:0 -504px}.flag.BZ{background-position:0 -518px}.flag.CA{background-position:0 -532px}.flag.CC{background-position:0 -546px}.flag.CD{background-position:0 -560px}.flag.CF{background-position:0 -574px}.flag.CG{background-position:0 -588px}.flag.CH{background-position:0 -602px}.flag.CI{background-position:0 -616px}.flag.CK{background-position:0 -630px}.flag.CL{background-position:0 -644px}.flag.CM{background-position:0 -658px}.flag.CN{background-position:0 -672px}.flag.CO{background-position:0 -686px}.flag.CP{background-position:0 -700px}.flag.CR{background-position:0 -714px}.flag.CU{background-position:0 -728px}.flag.CV{background-position:0 -742px}.flag.CW{background-position:0 -756px}.flag.CX{background-position:0 -770px}.flag.CY{background-position:0 -784px}.flag.CZ{background-position:0 -798px}.flag.DE{background-position:0 -812px}.flag.DG{background-position:0 -826px}.flag.DJ{background-position:0 -840px}.flag.DK{background-position:0 -854px}.flag.DM{background-position:0 -868px}.flag.DO{background-position:0 -882px}.flag.DZ{background-position:0 -896px}.flag.EA{background-position:0 -910px}.flag.EC{background-position:0 -924px}.flag.EE{background-position:0 -938px}.flag.EG{background-position:0 -952px}.flag.EH{background-position:0 -966px}.flag.ER{background-position:0 -980px}.flag.ES{background-position:0 -994px}.flag.ET{background-position:0 -1008px}.flag.EU{background-position:0 -1022px}.flag.FI{background-position:0 -1036px}.flag.FJ{background-position:0 -1050px}.flag.FK{background-position:0 -1064px}.flag.FM{background-position:0 -1078px}.flag.FO{background-position:0 -1092px}.flag.FR{background-position:0 -1106px}.flag.GA{background-position:0 -1120px}.flag.GB{background-position:0 -1134px}.flag.GD{background-position:0 -1148px}.flag.GE{background-position:0 -1162px}.flag.GF{background-position:0 -1176px}.flag.GG{background-position:0 -1190px}.flag.GH{background-position:0 -1204px}.flag.GI{background-position:0 -1218px}.flag.GL{background-position:0 -1232px}.flag.GM{background-position:0 -1246px}.flag.GN{background-position:0 -1260px}.flag.GP{background-position:0 -1274px}.flag.GQ{background-position:0 -1288px}.flag.GR{background-position:0 -1302px}.flag.GS{background-position:0 -1316px}.flag.GT{background-position:0 -1330px}.flag.GU{background-position:0 -1344px}.flag.GW{background-position:0 -1358px}.flag.GY{background-position:0 -1372px}.flag.HK{background-position:0 -1386px}.flag.HM{background-position:0 -1400px}.flag.HN{background-position:0 -1414px}.flag.HR{background-position:0 -1428px}.flag.HT{background-position:0 -1442px}.flag.HU{background-position:0 -1456px}.flag.IC{background-position:0 -1470px}.flag.ID{background-position:0 -1484px}.flag.IE{background-position:0 -1498px}.flag.IL{background-position:0 -1512px}.flag.IM{background-position:0 -1526px}.flag.IN{background-position:0 -1540px}.flag.IO{background-position:0 -1554px}.flag.IQ{background-position:0 -1568px}.flag.IR{background-position:0 -1582px}.flag.IS{background-position:0 -1596px}.flag.IT{background-position:0 -1610px}.flag.JE{background-position:0 -1624px}.flag.JM{background-position:0 -1638px}.flag.JO{background-position:0 -1652px}.flag.JP{background-position:0 -1666px}.flag.KE{background-position:0 -1680px}.flag.KG{background-position:0 -1694px}.flag.KH{background-position:0 -1708px}.flag.KI{background-position:0 -1722px}.flag.KM{background-position:0 -1736px}.flag.KN{background-position:0 -1750px}.flag.KP{background-position:0 -1764px}.flag.KR{background-position:0 -1778px}.flag.KW{background-position:0 -1792px}.flag.AD{background-position:0 -1806px}.flag.KZ{background-position:0 -1820px}.flag.LA{background-position:0 -1834px}.flag.LB{background-position:0 -1848px}.flag.LC{background-position:0 -1862px}.flag.LI{background-position:0 -1876px}.flag.LK{background-position:0 -1890px}.flag.LR{background-position:0 -1904px}.flag.LS{background-position:0 -1918px}.flag.LT{background-position:0 -1932px}.flag.LU{background-position:0 -1946px}.flag.LV{background-position:0 -1960px}.flag.LY{background-position:0 -1974px}.flag.MA{background-position:0 -1988px}.flag.MC{background-position:0 -2002px}.flag.MD{background-position:0 -2016px}.flag.ME{background-position:0 -2030px}.flag.MF{background-position:0 -2044px}.flag.MG{background-position:0 -2058px}.flag.MH{background-position:0 -2072px}.flag.MK{background-position:0 -2086px}.flag.ML{background-position:0 -2100px}.flag.MM{background-position:0 -2114px}.flag.MN{background-position:0 -2128px}.flag.MO{background-position:0 -2142px}.flag.MP{background-position:0 -2156px}.flag.MQ{background-position:0 -2170px}.flag.MR{background-position:0 -2184px}.flag.MS{background-position:0 -2198px}.flag.MT{background-position:0 -2212px}.flag.MU{background-position:0 -2226px}.flag.MV{background-position:0 -2240px}.flag.MW{background-position:0 -2254px}.flag.MX{background-position:0 -2268px}.flag.MY{background-position:0 -2282px}.flag.MZ{background-position:0 -2296px}.flag.NA{background-position:0 -2310px}.flag.NC{background-position:0 -2324px}.flag.NE{background-position:0 -2338px}.flag.NF{background-position:0 -2352px}.flag.NG{background-position:0 -2366px}.flag.NI{background-position:0 -2380px}.flag.NL{background-position:0 -2394px}.flag.NO{background-position:0 -2408px}.flag.NP{background-position:0 -2422px}.flag.NR{background-position:0 -2436px}.flag.NU{background-position:0 -2450px}.flag.NZ{background-position:0 -2464px}.flag.OM{background-position:0 -2478px}.flag.PA{background-position:0 -2492px}.flag.PE{background-position:0 -2506px}.flag.PF{background-position:0 -2520px}.flag.PG{background-position:0 -2534px}.flag.PH{background-position:0 -2548px}.flag.PK{background-position:0 -2562px}.flag.PL{background-position:0 -2576px}.flag.PM{background-position:0 -2590px}.flag.PN{background-position:0 -2604px}.flag.PR{background-position:0 -2618px}.flag.PS{background-position:0 -2632px}.flag.PT{background-position:0 -2646px}.flag.PW{background-position:0 -2660px}.flag.PY{background-position:0 -2674px}.flag.QA{background-position:0 -2688px}.flag.RE{background-position:0 -2702px}.flag.RO{background-position:0 -2716px}.flag.RS{background-position:0 -2730px}.flag.RU{background-position:0 -2744px}.flag.RW{background-position:0 -2758px}.flag.SA{background-position:0 -2772px}.flag.SB{background-position:0 -2786px}.flag.SC{background-position:0 -2800px}.flag.SD{background-position:0 -2814px}.flag.SE{background-position:0 -2828px}.flag.SG{background-position:0 -2842px}.flag.SH{background-position:0 -2856px}.flag.SI{background-position:0 -2870px}.flag.SJ{background-position:0 -2884px}.flag.SK{background-position:0 -2898px}.flag.SL{background-position:0 -2912px}.flag.SM{background-position:0 -2926px}.flag.SN{background-position:0 -2940px}.flag.SO{background-position:0 -2954px}.flag.SR{background-position:0 -2968px}.flag.SS{background-position:0 -2982px}.flag.ST{background-position:0 -2996px}.flag.SV{background-position:0 -3010px}.flag.SX{background-position:0 -3024px}.flag.SY{background-position:0 -3038px}.flag.SZ{background-position:0 -3052px}.flag.TA{background-position:0 -3066px}.flag.TC{background-position:0 -3080px}.flag.TD{background-position:0 -3094px}.flag.TF{background-position:0 -3108px}.flag.TG{background-position:0 -3122px}.flag.TH{background-position:0 -3136px}.flag.TJ{background-position:0 -3150px}.flag.TK{background-position:0 -3164px}.flag.TL{background-position:0 -3178px}.flag.TM{background-position:0 -3192px}.flag.TN{background-position:0 -3206px}.flag.TO{background-position:0 -3220px}.flag.TR{background-position:0 -3234px}.flag.TT{background-position:0 -3248px}.flag.TV{background-position:0 -3262px}.flag.TW{background-position:0 -3276px}.flag.TZ{background-position:0 -3290px}.flag.UA{background-position:0 -3304px}.flag.UG{background-position:0 -3318px}.flag.UM{background-position:0 -3332px}.flag.UN{background-position:0 -3346px}.flag.US{background-position:0 -3360px}.flag.UY{background-position:0 -3374px}.flag.UZ{background-position:0 -3388px}.flag.VA{background-position:0 -3402px}.flag.VC{background-position:0 -3416px}.flag.VE{background-position:0 -3430px}.flag.VG{background-position:0 -3444px}.flag.VI{background-position:0 -3458px}.flag.VN{background-position:0 -3472px}.flag.VU{background-position:0 -3486px}.flag.WF{background-position:0 -3500px}.flag.WS{background-position:0 -3514px}.flag.XK{background-position:0 -3528px}.flag.YE{background-position:0 -3542px}.flag.YT{background-position:0 -3556px}.flag.ZA{background-position:0 -3570px}.flag.ZM{background-position:0 -3584px}.flag.ZW{background-position:0 -3598px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i4.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i5.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i6.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i6.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i6.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: i7.MatDivider, selector: "mat-divider", inputs: ["vertical", "inset"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "pipe", type: SearchPipe, name: "search" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: LacMatCountrySelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lac-mat-country-selector', providers: [CountryCode], encapsulation: ViewEncapsulation.None, template: "<ng-container *ngIf=\"selectedCountry\">\n  <button\n    class=\"country-selector\"\n    type=\"button\"\n    mat-button\n    [matMenuTriggerFor]=\"menu\"\n    [disabled]=\"disabled\"\n    (click)=\"onOpenMenuClick()\">\n    <span class=\"country-selector-flag flag\" [ngClass]=\"selectedCountry.flagClass\"></span>\n    <span class=\"country-selector-code\" [hidden]=\"!showDialCode\">+{{ selectedCountry.dialCode }}</span>\n    <span class=\"country-arrow\"></span>\n  </button>\n  <mat-menu #menu=\"matMenu\" (closed)=\"onMenuClosed()\">\n    <div class=\"country-search-container\">\n      <mat-form-field class=\"country-search\" *ngIf=\"!disableSearch\" appearance=\"outline\" (click)=\"$event.stopPropagation()\">\n        <input\n          matInput\n          [(ngModel)]=\"searchQuery\"\n          type=\"text\"\n          [placeholder]=\"searchPlaceholder\"\n          #searchInput=\"matInput\"/>\n      </mat-form-field>\n    </div>\n    \n    <button type=\"button\" mat-menu-item class=\"country-list-button\" *ngFor=\"let country of preferredCountriesInDropDown\" (click)=\"selectCountry(country)\">\n      <div class=\"icon-wrapper\">\n        <div class=\"flag\" [ngClass]=\"country.flagClass\"></div>\n      </div>\n      <div class=\"label-wrapper\">{{country.name}} +{{country.dialCode}}</div>\n    </button>\n    <mat-divider *ngIf=\"preferredCountriesInDropDown?.length\"></mat-divider>\n    \n    <ng-container *ngFor=\"let country of allCountries\">\n      <button type=\"button\" mat-menu-item class=\"country-list-button\" *ngIf=\"country.name | search:searchQuery\" (click)=\"selectCountry(country)\">\n        <div class=\"icon-wrapper\">\n          <div class=\"flag\" [ngClass]=\"country.flagClass\"></div>\n        </div>\n        <div class=\"label-wrapper\">{{country.name}} +{{country.dialCode}}</div>\n      </button>\n    </ng-container>\n  </mat-menu>\n</ng-container>", styles: [".flag{background-image:url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/flags_sprite_2x.png);background-size:100% auto;filter:drop-shadow(1px 1px 1px rgba(0,0,0,.54));height:14px;width:24px}.country-selector-flag{display:inline-block;margin-right:5px}.country-selector-code{margin-right:5px;font-size:initial;font-weight:initial}.icon-wrapper,.label-wrapper{display:table-cell;vertical-align:middle}.icon-wrapper{padding-right:15px}.country-arrow{width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid;margin:0 4px;color:#0000008a;display:table-cell;vertical-align:middle}.country-search-container{padding:10px}.mat-form-field.country-search{width:100%}.mat-form-field.country-search .mat-form-field-infix{padding:0 0 10px}.mat-form-field.country-search .mat-form-field-wrapper{padding-bottom:0}.flag.KY{background-position:0 0}.flag.AC{background-position:0 -14px}.flag.AE{background-position:0 -28px}.flag.AF{background-position:0 -42px}.flag.AG{background-position:0 -56px}.flag.AI{background-position:0 -70px}.flag.AL{background-position:0 -84px}.flag.AM{background-position:0 -98px}.flag.AO{background-position:0 -112px}.flag.AQ{background-position:0 -126px}.flag.AR{background-position:0 -140px}.flag.AS{background-position:0 -154px}.flag.AT{background-position:0 -168px}.flag.AU{background-position:0 -182px}.flag.AW{background-position:0 -196px}.flag.AX{background-position:0 -210px}.flag.AZ{background-position:0 -224px}.flag.BA{background-position:0 -238px}.flag.BB{background-position:0 -252px}.flag.BD{background-position:0 -266px}.flag.BE{background-position:0 -280px}.flag.BF{background-position:0 -294px}.flag.BG{background-position:0 -308px}.flag.BH{background-position:0 -322px}.flag.BI{background-position:0 -336px}.flag.BJ{background-position:0 -350px}.flag.BL{background-position:0 -364px}.flag.BM{background-position:0 -378px}.flag.BN{background-position:0 -392px}.flag.BO{background-position:0 -406px}.flag.BQ{background-position:0 -420px}.flag.BR{background-position:0 -434px}.flag.BS{background-position:0 -448px}.flag.BT{background-position:0 -462px}.flag.BV{background-position:0 -476px}.flag.BW{background-position:0 -490px}.flag.BY{background-position:0 -504px}.flag.BZ{background-position:0 -518px}.flag.CA{background-position:0 -532px}.flag.CC{background-position:0 -546px}.flag.CD{background-position:0 -560px}.flag.CF{background-position:0 -574px}.flag.CG{background-position:0 -588px}.flag.CH{background-position:0 -602px}.flag.CI{background-position:0 -616px}.flag.CK{background-position:0 -630px}.flag.CL{background-position:0 -644px}.flag.CM{background-position:0 -658px}.flag.CN{background-position:0 -672px}.flag.CO{background-position:0 -686px}.flag.CP{background-position:0 -700px}.flag.CR{background-position:0 -714px}.flag.CU{background-position:0 -728px}.flag.CV{background-position:0 -742px}.flag.CW{background-position:0 -756px}.flag.CX{background-position:0 -770px}.flag.CY{background-position:0 -784px}.flag.CZ{background-position:0 -798px}.flag.DE{background-position:0 -812px}.flag.DG{background-position:0 -826px}.flag.DJ{background-position:0 -840px}.flag.DK{background-position:0 -854px}.flag.DM{background-position:0 -868px}.flag.DO{background-position:0 -882px}.flag.DZ{background-position:0 -896px}.flag.EA{background-position:0 -910px}.flag.EC{background-position:0 -924px}.flag.EE{background-position:0 -938px}.flag.EG{background-position:0 -952px}.flag.EH{background-position:0 -966px}.flag.ER{background-position:0 -980px}.flag.ES{background-position:0 -994px}.flag.ET{background-position:0 -1008px}.flag.EU{background-position:0 -1022px}.flag.FI{background-position:0 -1036px}.flag.FJ{background-position:0 -1050px}.flag.FK{background-position:0 -1064px}.flag.FM{background-position:0 -1078px}.flag.FO{background-position:0 -1092px}.flag.FR{background-position:0 -1106px}.flag.GA{background-position:0 -1120px}.flag.GB{background-position:0 -1134px}.flag.GD{background-position:0 -1148px}.flag.GE{background-position:0 -1162px}.flag.GF{background-position:0 -1176px}.flag.GG{background-position:0 -1190px}.flag.GH{background-position:0 -1204px}.flag.GI{background-position:0 -1218px}.flag.GL{background-position:0 -1232px}.flag.GM{background-position:0 -1246px}.flag.GN{background-position:0 -1260px}.flag.GP{background-position:0 -1274px}.flag.GQ{background-position:0 -1288px}.flag.GR{background-position:0 -1302px}.flag.GS{background-position:0 -1316px}.flag.GT{background-position:0 -1330px}.flag.GU{background-position:0 -1344px}.flag.GW{background-position:0 -1358px}.flag.GY{background-position:0 -1372px}.flag.HK{background-position:0 -1386px}.flag.HM{background-position:0 -1400px}.flag.HN{background-position:0 -1414px}.flag.HR{background-position:0 -1428px}.flag.HT{background-position:0 -1442px}.flag.HU{background-position:0 -1456px}.flag.IC{background-position:0 -1470px}.flag.ID{background-position:0 -1484px}.flag.IE{background-position:0 -1498px}.flag.IL{background-position:0 -1512px}.flag.IM{background-position:0 -1526px}.flag.IN{background-position:0 -1540px}.flag.IO{background-position:0 -1554px}.flag.IQ{background-position:0 -1568px}.flag.IR{background-position:0 -1582px}.flag.IS{background-position:0 -1596px}.flag.IT{background-position:0 -1610px}.flag.JE{background-position:0 -1624px}.flag.JM{background-position:0 -1638px}.flag.JO{background-position:0 -1652px}.flag.JP{background-position:0 -1666px}.flag.KE{background-position:0 -1680px}.flag.KG{background-position:0 -1694px}.flag.KH{background-position:0 -1708px}.flag.KI{background-position:0 -1722px}.flag.KM{background-position:0 -1736px}.flag.KN{background-position:0 -1750px}.flag.KP{background-position:0 -1764px}.flag.KR{background-position:0 -1778px}.flag.KW{background-position:0 -1792px}.flag.AD{background-position:0 -1806px}.flag.KZ{background-position:0 -1820px}.flag.LA{background-position:0 -1834px}.flag.LB{background-position:0 -1848px}.flag.LC{background-position:0 -1862px}.flag.LI{background-position:0 -1876px}.flag.LK{background-position:0 -1890px}.flag.LR{background-position:0 -1904px}.flag.LS{background-position:0 -1918px}.flag.LT{background-position:0 -1932px}.flag.LU{background-position:0 -1946px}.flag.LV{background-position:0 -1960px}.flag.LY{background-position:0 -1974px}.flag.MA{background-position:0 -1988px}.flag.MC{background-position:0 -2002px}.flag.MD{background-position:0 -2016px}.flag.ME{background-position:0 -2030px}.flag.MF{background-position:0 -2044px}.flag.MG{background-position:0 -2058px}.flag.MH{background-position:0 -2072px}.flag.MK{background-position:0 -2086px}.flag.ML{background-position:0 -2100px}.flag.MM{background-position:0 -2114px}.flag.MN{background-position:0 -2128px}.flag.MO{background-position:0 -2142px}.flag.MP{background-position:0 -2156px}.flag.MQ{background-position:0 -2170px}.flag.MR{background-position:0 -2184px}.flag.MS{background-position:0 -2198px}.flag.MT{background-position:0 -2212px}.flag.MU{background-position:0 -2226px}.flag.MV{background-position:0 -2240px}.flag.MW{background-position:0 -2254px}.flag.MX{background-position:0 -2268px}.flag.MY{background-position:0 -2282px}.flag.MZ{background-position:0 -2296px}.flag.NA{background-position:0 -2310px}.flag.NC{background-position:0 -2324px}.flag.NE{background-position:0 -2338px}.flag.NF{background-position:0 -2352px}.flag.NG{background-position:0 -2366px}.flag.NI{background-position:0 -2380px}.flag.NL{background-position:0 -2394px}.flag.NO{background-position:0 -2408px}.flag.NP{background-position:0 -2422px}.flag.NR{background-position:0 -2436px}.flag.NU{background-position:0 -2450px}.flag.NZ{background-position:0 -2464px}.flag.OM{background-position:0 -2478px}.flag.PA{background-position:0 -2492px}.flag.PE{background-position:0 -2506px}.flag.PF{background-position:0 -2520px}.flag.PG{background-position:0 -2534px}.flag.PH{background-position:0 -2548px}.flag.PK{background-position:0 -2562px}.flag.PL{background-position:0 -2576px}.flag.PM{background-position:0 -2590px}.flag.PN{background-position:0 -2604px}.flag.PR{background-position:0 -2618px}.flag.PS{background-position:0 -2632px}.flag.PT{background-position:0 -2646px}.flag.PW{background-position:0 -2660px}.flag.PY{background-position:0 -2674px}.flag.QA{background-position:0 -2688px}.flag.RE{background-position:0 -2702px}.flag.RO{background-position:0 -2716px}.flag.RS{background-position:0 -2730px}.flag.RU{background-position:0 -2744px}.flag.RW{background-position:0 -2758px}.flag.SA{background-position:0 -2772px}.flag.SB{background-position:0 -2786px}.flag.SC{background-position:0 -2800px}.flag.SD{background-position:0 -2814px}.flag.SE{background-position:0 -2828px}.flag.SG{background-position:0 -2842px}.flag.SH{background-position:0 -2856px}.flag.SI{background-position:0 -2870px}.flag.SJ{background-position:0 -2884px}.flag.SK{background-position:0 -2898px}.flag.SL{background-position:0 -2912px}.flag.SM{background-position:0 -2926px}.flag.SN{background-position:0 -2940px}.flag.SO{background-position:0 -2954px}.flag.SR{background-position:0 -2968px}.flag.SS{background-position:0 -2982px}.flag.ST{background-position:0 -2996px}.flag.SV{background-position:0 -3010px}.flag.SX{background-position:0 -3024px}.flag.SY{background-position:0 -3038px}.flag.SZ{background-position:0 -3052px}.flag.TA{background-position:0 -3066px}.flag.TC{background-position:0 -3080px}.flag.TD{background-position:0 -3094px}.flag.TF{background-position:0 -3108px}.flag.TG{background-position:0 -3122px}.flag.TH{background-position:0 -3136px}.flag.TJ{background-position:0 -3150px}.flag.TK{background-position:0 -3164px}.flag.TL{background-position:0 -3178px}.flag.TM{background-position:0 -3192px}.flag.TN{background-position:0 -3206px}.flag.TO{background-position:0 -3220px}.flag.TR{background-position:0 -3234px}.flag.TT{background-position:0 -3248px}.flag.TV{background-position:0 -3262px}.flag.TW{background-position:0 -3276px}.flag.TZ{background-position:0 -3290px}.flag.UA{background-position:0 -3304px}.flag.UG{background-position:0 -3318px}.flag.UM{background-position:0 -3332px}.flag.UN{background-position:0 -3346px}.flag.US{background-position:0 -3360px}.flag.UY{background-position:0 -3374px}.flag.UZ{background-position:0 -3388px}.flag.VA{background-position:0 -3402px}.flag.VC{background-position:0 -3416px}.flag.VE{background-position:0 -3430px}.flag.VG{background-position:0 -3444px}.flag.VI{background-position:0 -3458px}.flag.VN{background-position:0 -3472px}.flag.VU{background-position:0 -3486px}.flag.WF{background-position:0 -3500px}.flag.WS{background-position:0 -3514px}.flag.XK{background-position:0 -3528px}.flag.YE{background-position:0 -3542px}.flag.YT{background-position:0 -3556px}.flag.ZA{background-position:0 -3570px}.flag.ZM{background-position:0 -3584px}.flag.ZW{background-position:0 -3598px}\n"] }]
        }], ctorParameters: function () { return [{ type: CountryCode }]; }, propDecorators: { selectorFor: [{
                type: Input
            }], preferredCountries: [{
                type: Input
            }], onlyCountries: [{
                type: Input
            }], showDialCode: [{
                type: Input
            }], disableSearch: [{
                type: Input
            }], searchPlaceholder: [{
                type: Input
            }], change: [{
                type: Output
            }], searchInput: [{
                type: ViewChild,
                args: ['searchInput']
            }] } });

class LacMatTelInputComponent {
    // ControlValueAccessor - END
    constructor(ngControl, fm, elRef) {
        this.ngControl = ngControl;
        this.fm = fm;
        this.elRef = elRef;
        this.blur = new EventEmitter();
        this.PhoneNumberMaxDigits = 20;
        this.maxInputLength = this.PhoneNumberMaxDigits;
        // Subject to notify when country needs to be update from input
        // Se paste condition in onInputChanged
        this.countryChange = new Subject();
        // Mat Form Field implementation - BEGIN
        this.stateChanges = new Subject();
        this.id = `lac-mat-tel-input-${LacMatTelInputComponent.nextId++}`;
        // ngControl: NgControl; set with Dependency Injection
        this.focused = false;
        // adds a required indicator to the label/placeholder
        this._required = false;
        this.inputDisabled = false;
        this.controlType = 'mat-tel';
        this.describedBy = '';
        this.onTouched = () => { };
        this.propagateChange = (_) => { };
        if (this.ngControl != null) {
            // Setting the value accessor directly (instead of using
            // the providers) to avoid running into a circular import.
            this.ngControl.valueAccessor = this;
        }
        fm.monitor(elRef.nativeElement, true).subscribe((origin) => {
            this.focused = !!origin;
            this.stateChanges.next();
        });
    }
    set value(v) {
        //whenever value changes -> this.stateChanges.next(); so form-field runs change detection
        this._value = v ? `+${getCountryCallingCode(this.selectedCountry)} ${v}` : v;
        this.propagateChange(this._value);
        this.stateChanges.next();
    }
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(val) {
        this._placeholder = val;
        this.stateChanges.next();
    }
    get empty() {
        return !this.phone;
    }
    // shouldLabelFloat: boolean;
    get shouldLabelFloat() {
        return this.focused || !this.empty;
    }
    get required() {
        return this._required;
    }
    set required(req) {
        this._required = coerceBooleanProperty(req);
        this.stateChanges.next();
    }
    get disabled() {
        return this.inputDisabled || this.ngControl?.disabled || false;
    }
    set disabled(value) {
        this.inputDisabled = coerceBooleanProperty(value);
        this.stateChanges.next();
    }
    get errorState() {
        return this.ngControl && this.ngControl.errors !== null && !!this.ngControl.touched;
    }
    setDescribedByIds(ids) {
        this.describedBy = ids.join(' ');
    }
    onContainerClick(event) {
        if (!this.disabled) {
            this.onTouched();
        }
    }
    // Mat Form Field implementation - END
    // ControlValueAccessor - BEGIN
    writeValue(value) {
        this.onInputChanged(value);
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    ngOnDestroy() {
        this.fm.stopMonitoring(this.elRef.nativeElement);
        this.countryChange.complete();
        this.stateChanges.complete();
    }
    onCountrySelected(code, noPhoneReset) {
        let hasCountryChanged = this.selectedCountry && this.selectedCountry != code;
        this.selectedCountry = code;
        let example = getExampleNumber(code, Examples)?.formatNational();
        let numbersOnly = example?.replace(/[^\d]/g, '');
        let maxExample = numbersOnly + '9999999999';
        this.maxInputLength = this.PhoneNumberMaxDigits;
        //find out the maximum (formatted) size a valid number for the country can have
        for (let i = maxExample.length; i >= 0; i--) {
            let test = maxExample.substring(0, i);
            let testPhone = parsePhoneNumberFromString(test, code);
            if (testPhone && testPhone.isValid()) {
                let maxInput = new AsYouType(code).input(test);
                this.maxInputLength = maxInput.length;
                this.placeholder = maxInput; //TODO set placeholder optionally
                break;
            }
        }
        //when new country is selected reset phone if phone reset was not disabled
        if (hasCountryChanged && !noPhoneReset) {
            this.phone = '';
            this.value = this.phone;
            //focus on input
            if (this.phoneInput) {
                setTimeout(() => this.phoneInput.focus());
            }
        }
    }
    onInputChanged(e) {
        if (!e) {
            e = '';
        }
        this.phone = e;
        if (e.startsWith('+')) {
            // handles pasting of a complete international number
            try {
                let pastedNumber = parsePhoneNumberFromString(e);
                if (pastedNumber && pastedNumber.country) {
                    let code = pastedNumber.country;
                    this.onCountrySelected(code, true);
                    this.countryChange.next(code);
                    setTimeout(() => {
                        this.phone = pastedNumber?.formatNational();
                        this.value = this.phone;
                    });
                    return;
                }
            }
            catch { }
        }
        // let numbersOnly = e.replace(/[^\d]/g, '');
        let numbersOnly = e.replace(/[^\d\+]/g, '');
        setTimeout(() => {
            let formatted = new AsYouType(this.selectedCountry).input(numbersOnly);
            // if the formatted output equals what we already have then the user is trying to delete a symbol inserted by
            // the formatted version
            this.phone = formatted.substr(0, formatted.length - 1) === this.phone ? numbersOnly : formatted;
            this.value = this.phone;
        }, 0);
    }
    onInputKeyPress(event) {
        const allowedChars = /[0-9\+\-\ ]/;
        const allowedCtrlChars = /[axcv]/; // Allows copy-pasting
        const allowedOtherKeys = [
            'ArrowLeft',
            'ArrowUp',
            'ArrowRight',
            'ArrowDown',
            'Home',
            'End',
            'Insert',
            'Delete',
            'Backspace',
        ];
        if (!allowedChars.test(event.key) &&
            !(event.ctrlKey && allowedCtrlChars.test(event.key)) &&
            !allowedOtherKeys.includes(event.key)) {
            event.preventDefault();
        }
    }
}
// the id of an element to associate labels and hints with.
LacMatTelInputComponent.nextId = 0;
LacMatTelInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: LacMatTelInputComponent, deps: [{ token: i1$3.NgControl, optional: true, self: true }, { token: i2.FocusMonitor }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
LacMatTelInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: LacMatTelInputComponent, selector: "lac-mat-tel-input", inputs: { required: "required", disabled: "disabled" }, outputs: { blur: "blur" }, host: { properties: { "id": "this.id", "class.floating": "this.shouldLabelFloat", "attr.aria-describedby": "this.describedBy" } }, providers: [{ provide: MatFormFieldControl, useExisting: LacMatTelInputComponent }], viewQueries: [{ propertyName: "phoneInput", first: true, predicate: ["phoneInput"], descendants: true, static: true }], ngImport: i0, template: "<input\n  type=\"text\"\n  matInput\n  #phoneInput=\"matInput\"\n  [ngModel]=\"phone\"\n  (blur)=\"blur.emit($event)\"\n  (keypress)=\"onInputKeyPress($event)\"\n  (ngModelChange)=\"onInputChanged($event)\"\n  [disabled]=\"disabled\"\n  [maxlength]=\"!phone ? PhoneNumberMaxDigits : maxInputLength\"\n  [placeholder]=\"placeholder\" />\n", styles: [""], dependencies: [{ kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i5.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: LacMatTelInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lac-mat-tel-input', providers: [{ provide: MatFormFieldControl, useExisting: LacMatTelInputComponent }], template: "<input\n  type=\"text\"\n  matInput\n  #phoneInput=\"matInput\"\n  [ngModel]=\"phone\"\n  (blur)=\"blur.emit($event)\"\n  (keypress)=\"onInputKeyPress($event)\"\n  (ngModelChange)=\"onInputChanged($event)\"\n  [disabled]=\"disabled\"\n  [maxlength]=\"!phone ? PhoneNumberMaxDigits : maxInputLength\"\n  [placeholder]=\"placeholder\" />\n" }]
        }], ctorParameters: function () { return [{ type: i1$3.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i2.FocusMonitor }, { type: i0.ElementRef }]; }, propDecorators: { blur: [{
                type: Output
            }], phoneInput: [{
                type: ViewChild,
                args: ['phoneInput', { static: true }]
            }], id: [{
                type: HostBinding
            }], shouldLabelFloat: [{
                type: HostBinding,
                args: ['class.floating']
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input
            }], describedBy: [{
                type: HostBinding,
                args: ['attr.aria-describedby']
            }] } });

class LacMatTelInputModule {
}
LacMatTelInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: LacMatTelInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LacMatTelInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: LacMatTelInputModule, declarations: [LacMatTelInputComponent, LacMatCountrySelectorComponent, SearchPipe], imports: [CommonModule,
        FormsModule,
        MatInputModule,
        MatMenuModule,
        MatDividerModule,
        MatButtonModule,
        ReactiveFormsModule], exports: [LacMatTelInputComponent, LacMatCountrySelectorComponent] });
LacMatTelInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: LacMatTelInputModule, imports: [CommonModule,
        FormsModule,
        MatInputModule,
        MatMenuModule,
        MatDividerModule,
        MatButtonModule,
        ReactiveFormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: LacMatTelInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LacMatTelInputComponent, LacMatCountrySelectorComponent, SearchPipe],
                    imports: [
                        CommonModule,
                        FormsModule,
                        MatInputModule,
                        MatMenuModule,
                        MatDividerModule,
                        MatButtonModule,
                        ReactiveFormsModule
                    ],
                    exports: [LacMatTelInputComponent, LacMatCountrySelectorComponent]
                }]
        }] });

const phoneNumberValidator = (control) => {
    const error = { invalidPhone: true };
    let numberInstance;
    if (control.value) {
        try {
            numberInstance = parsePhoneNumber(control.value);
        }
        catch (e) {
            return error;
        }
        if (numberInstance && !numberInstance.isValid()) {
            return error;
        }
    }
    /**
     * @todo [Paulo Santos] Review this return statement...
     */
    return;
};

const defaultConfig$1 = {
    production: false,
    useNgDefaultLogging: false,
    apiUrl: '',
    storagePrefixKey: '_fm_log_',
    appName: null,
    maxErrorBulkSize: 10,
    blacklistedStatusCodes: [400, 401, 404, 423],
    enableFmLoggerAsGlobal: true,
};

const FM_ERROR_CONFIG = new InjectionToken('FM_ERROR_CONFIG', {
    providedIn: 'root',
    factory: () => defaultConfig$1,
});
const FM_ERROR_HANDLER_CLASS = new InjectionToken('FM_ERROR_HANDLER_CLASS');

var FmApps;
(function (FmApps) {
    FmApps["DOCTORS_PORTAL"] = "DOCTORS_PORTAL";
    FmApps["DISPENSATION_PORTAL"] = "DISPENSATION_PORTAL";
    FmApps["PATIENT_PORTAL"] = "PATIENT_PORTAL";
    FmApps["BACKOFFICE"] = "BACKOFFICE";
    FmApps["ONBOARDING_PORTAL"] = "ONBOARDING_PORTAL";
    FmApps["REGISTRATION_WIDGET"] = "REGISTRATION_WIDGET";
})(FmApps || (FmApps = {}));
var FmErrorTypeEnum;
(function (FmErrorTypeEnum) {
    FmErrorTypeEnum["API_REQUEST"] = "API_REQUEST";
    FmErrorTypeEnum["APP_ERROR"] = "APP_ERROR";
    FmErrorTypeEnum["CUSTOM_LOGGING"] = "CUSTOM_LOGGING";
})(FmErrorTypeEnum || (FmErrorTypeEnum = {}));
var FmLogLevels;
(function (FmLogLevels) {
    FmLogLevels[FmLogLevels["Debug"] = 1] = "Debug";
    FmLogLevels[FmLogLevels["Info"] = 2] = "Info";
    FmLogLevels[FmLogLevels["Warn"] = 3] = "Warn";
    FmLogLevels[FmLogLevels["Error"] = 4] = "Error";
    FmLogLevels[FmLogLevels["Fatal"] = 5] = "Fatal";
})(FmLogLevels || (FmLogLevels = {}));

/**
 * Secure Hash Algorithm (SHA1)
 * http://www.webtoolkit.info/
 **/
function SHA1(msg) {
    function rotate_left(n, s) {
        var t4 = (n << s) | (n >>> (32 - s));
        return t4;
    }
    function lsb_hex(val) {
        var str = '';
        var i;
        var vh;
        var vl;
        for (i = 0; i <= 6; i += 2) {
            vh = (val >>> (i * 4 + 4)) & 0x0f;
            vl = (val >>> (i * 4)) & 0x0f;
            str += vh.toString(16) + vl.toString(16);
        }
        return str;
    }
    function cvt_hex(val) {
        var str = '';
        var i;
        var v;
        for (i = 7; i >= 0; i--) {
            v = (val >>> (i * 4)) & 0x0f;
            str += v.toString(16);
        }
        return str;
    }
    function Utf8Encode(string) {
        string = string.replace(/\r\n/g, '\n');
        var utftext = '';
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            }
            else if (c > 127 && c < 2048) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            }
            else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }
        }
        return utftext;
    }
    var blockstart;
    var i, j;
    var W = new Array(80);
    var H0 = 0x67452301;
    var H1 = 0xefcdab89;
    var H2 = 0x98badcfe;
    var H3 = 0x10325476;
    var H4 = 0xc3d2e1f0;
    var A, B, C, D, E;
    var temp;
    msg = Utf8Encode(msg);
    var msg_len = msg.length;
    var word_array = new Array();
    for (i = 0; i < msg_len - 3; i += 4) {
        j =
            (msg.charCodeAt(i) << 24) |
                (msg.charCodeAt(i + 1) << 16) |
                (msg.charCodeAt(i + 2) << 8) |
                msg.charCodeAt(i + 3);
        word_array.push(j);
    }
    switch (msg_len % 4) {
        case 0:
            i = 0x080000000;
            break;
        case 1:
            i = (msg.charCodeAt(msg_len - 1) << 24) | 0x0800000;
            break;
        case 2:
            i = (msg.charCodeAt(msg_len - 2) << 24) | (msg.charCodeAt(msg_len - 1) << 16) | 0x08000;
            break;
        case 3:
            i =
                (msg.charCodeAt(msg_len - 3) << 24) |
                    (msg.charCodeAt(msg_len - 2) << 16) |
                    (msg.charCodeAt(msg_len - 1) << 8) |
                    0x80;
            break;
    }
    word_array.push(i);
    while (word_array.length % 16 != 14)
        word_array.push(0);
    word_array.push(msg_len >>> 29);
    word_array.push((msg_len << 3) & 0x0ffffffff);
    for (blockstart = 0; blockstart < word_array.length; blockstart += 16) {
        for (i = 0; i < 16; i++)
            W[i] = word_array[blockstart + i];
        for (i = 16; i <= 79; i++)
            W[i] = rotate_left(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
        A = H0;
        B = H1;
        C = H2;
        D = H3;
        E = H4;
        for (i = 0; i <= 19; i++) {
            temp = (rotate_left(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5a827999) & 0x0ffffffff;
            E = D;
            D = C;
            C = rotate_left(B, 30);
            B = A;
            A = temp;
        }
        for (i = 20; i <= 39; i++) {
            temp = (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1) & 0x0ffffffff;
            E = D;
            D = C;
            C = rotate_left(B, 30);
            B = A;
            A = temp;
        }
        for (i = 40; i <= 59; i++) {
            temp = (rotate_left(A, 5) + ((B & C) | (B & D) | (C & D)) + E + W[i] + 0x8f1bbcdc) & 0x0ffffffff;
            E = D;
            D = C;
            C = rotate_left(B, 30);
            B = A;
            A = temp;
        }
        for (i = 60; i <= 79; i++) {
            temp = (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6) & 0x0ffffffff;
            E = D;
            D = C;
            C = rotate_left(B, 30);
            B = A;
            A = temp;
        }
        H0 = (H0 + A) & 0x0ffffffff;
        H1 = (H1 + B) & 0x0ffffffff;
        H2 = (H2 + C) & 0x0ffffffff;
        H3 = (H3 + D) & 0x0ffffffff;
        H4 = (H4 + E) & 0x0ffffffff;
    }
    temp = cvt_hex(H0) + cvt_hex(H1) + cvt_hex(H2) + cvt_hex(H3) + cvt_hex(H4);
    return temp.toLowerCase();
}

let FmErrorHandler = class FmErrorHandler extends ErrorHandler {
    constructor(config) {
        super();
        this.config = config;
        /**
         * Collect all error ids
         */
        this._errorIds = new BehaviorSubject([]);
        /**
         * The version of the logger package.
         * Each time something is changed in this logger,
         * the version should be updated.
         */
        this.fmLoggerVersion = '1.0.1';
        /**
         * Max bulk size length
         */
        this.maxErrorBulkSize = 10;
        /**
         * Does not report if the error has status code listed here
         * and if the error type match 'API_REQUEST'.
         */
        this.blacklistedStatusCodes = [400, 401, 404, 423];
        /**
         * App name for identification errors.
         */
        this.appName = FmApps.DOCTORS_PORTAL;
        if (this.config.enableFmLoggerAsGlobal) {
            window['FmErrorHandler'] = this;
        }
        Object.assign(this, this.config);
        this.handleStoredErrors();
    }
    /**
     * Handle whole log process, including api requests.
     *
     * @param error
     * @returns void
     */
    handleError(error) {
        if (this.config.useNgDefaultLogging) {
            super.handleError(error);
        }
        if (this.isBlascklisted(error))
            return;
        this.errorType = error instanceof HttpErrorResponse ? FmErrorTypeEnum.API_REQUEST : FmErrorTypeEnum.APP_ERROR;
        let shouldCollectErrors = true;
        if (this.errorType === FmErrorTypeEnum.APP_ERROR) {
            error = {
                message: error.message,
                stack: error?.stack,
            };
        }
        if (error.stack) {
            this.errorId = this._setErrorId(error);
            shouldCollectErrors = !this._errorIds.value.includes(this.errorId);
            const errors = new Set([...this._errorIds.value, this.errorId]);
            this._errorIds.next(Array.from(errors));
        }
        this.error = error;
        this._debug();
        if (shouldCollectErrors) {
            this._collectErrors();
        }
    }
    /**
     * Set id for the error.
     *
     * @param error
     * @returns
     */
    _setErrorId(error) {
        let file = error.stack.split('\n')?.[1];
        for (let i = 0; i < file?.length; i++) {
            if (file[i] !== ' ') {
                file = file.substr(i);
                break;
            }
        }
        return SHA1(error.message + file);
    }
    /**
     * Prints error on developers console.
     */
    _debug() {
        if (!this.config.production) {
            console.log(`%c[${this?.errorType}]: %c${this?.error?.message || '---'}`, 'color: yellow', 'color: green');
            if ('stack' in this.error) {
                console.error(this.error.stack);
            }
        }
    }
    /**
     * Compose error and store.
     */
    async _collectErrors() {
        const fm_build_version = navigator.onLine ? await this.fmVersionBuild : 'offline';
        let data = [
            {
                error_id: this.errorId,
                log_level: 'Info',
                error: this.error,
                app: { ...this.appErrors, fm_build_version },
                navigator: this.navigatorErrors,
                type: this.errorType,
                app_name: this.appName,
            },
        ];
        /**
         * If the state of the network is false (offline) then
         * we store the collected data on local storage in order
         * to send to FM Logger API once the user agent come back
         * to online mode again.
         */
        if (!navigator.onLine) {
            this.localStore(data);
        }
        else {
            this._reportApi(data);
        }
        data = null;
    }
    get appErrors() {
        return {
            angular_version: VERSION.full,
            reported_at: Date.now(),
        };
    }
    get fmVersionBuild() {
        if (this.config.production === false) {
            return Promise.resolve('development');
        }
        return new Promise((resolve) => {
            const xmlHttp = new XMLHttpRequest();
            xmlHttp.open('get', `${this._versionVerUrl}version.ver`, false);
            xmlHttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xmlHttp.onreadystatechange = function () {
                if (xmlHttp.readyState === XMLHttpRequest.DONE && this.status === 404) {
                    resolve('no-version-available');
                }
                if (xmlHttp.readyState === XMLHttpRequest.DONE) {
                    const { version } = JSON.parse(xmlHttp.responseText);
                    resolve(version);
                }
            };
            xmlHttp.send(null);
        });
    }
    get navigatorErrors() {
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        return {
            app_code_name: navigator?.appCodeName,
            app_name: navigator?.appName,
            app_version: navigator?.appVersion,
            language: navigator.language,
            platform: navigator?.platform,
            connection: {
                effectiveType: connection?.effectiveType,
                downlink: connection?.downlink,
                rtt: connection?.rtt,
                isOnline: navigator?.onLine,
            },
            user_agent: navigator.userAgent,
            vendor: navigator.vendor,
            product_sub: navigator?.productSub,
            product: navigator?.product,
            window_width: window.innerWidth,
            window_height: window.innerHeight,
            location_href: window.location.href,
        };
    }
    localStore(data) {
        try {
            if (typeof data === 'object') {
                data = data.map((v) => {
                    if (v?.error?.message?.startsWith('Uncaught (in promise)')) {
                        return {
                            ...v,
                            error: {
                                message: 'Chunk loading error, this may occur when offline requests happen to modules',
                            },
                        };
                    }
                    return v;
                });
                data = JSON.stringify(data);
            }
            localStorage.setItem(this.storagePrefixKey + Date.now(), data);
        }
        catch (e) {
            this.err(e.message);
            this.clearStorage();
        }
    }
    clearStorage() {
        Object.entries(localStorage)
            .map(([key]) => key)
            .forEach((key) => {
            if (key.includes(this.storagePrefixKey)) {
                localStorage.removeItem(key);
            }
        });
    }
    /**
     * Call API, send error.
     *
     * @param errors
     * @returns
     */
    _reportApi(errors) {
        return new Promise((resolve) => {
            errors = typeof errors === 'object' ? JSON.stringify(errors) : errors;
            const xmlHttp = new XMLHttpRequest();
            xmlHttp.open('POST', this.config.apiUrl, true);
            xmlHttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            const jwt = localStorage.getItem('access_token');
            if (jwt) {
                xmlHttp.setRequestHeader('Authorization', `Bearer ${jwt}`);
            }
            xmlHttp.send(errors);
            xmlHttp.onreadystatechange = function () {
                if (xmlHttp.readyState === XMLHttpRequest.DONE) {
                    resolve(xmlHttp.status);
                }
            };
        });
    }
    /**
     * Initialize network changes and report
     * the previous stored errors.
     */
    async handleStoredErrors() {
        const cb = async () => {
            const storage = Object.entries(localStorage);
            let errors = [];
            storage
                .map(([key, value]) => ({ key, value }))
                .forEach((entry) => {
                if (entry.key.includes(this.storagePrefixKey) && errors.length < this.maxErrorBulkSize) {
                    errors = [...errors, ...JSON.parse(entry.value)];
                }
            });
            /**
             * Send error to FM API.
             */
            if (errors && errors.length > 0) {
                const response = await this._reportApi(JSON.stringify(errors));
                /**
                 * If the API response is success,
                 * remove from storage all stored errors.
                 */
                if (response === 201 /* HttpStatusCode.Created */) {
                    this.clearStorage();
                }
            }
            errors = [];
        };
        /**
         * Execute pending stored errors if they exists.
         */
        const hasErrors = Object.keys(localStorage).filter((key) => key.startsWith(this.storagePrefixKey)).length > 0;
        if (hasErrors) {
            cb();
        }
        window.addEventListener('online', cb);
    }
    isBlascklisted(error) {
        return error instanceof HttpErrorResponse && this.blacklistedStatusCodes.includes(error?.status);
    }
    logReport(log_level, data, send_to_api = true) {
        let levelColor = '';
        let levelName = '';
        if (typeof log_level === 'string') {
            log_level.toLowerCase();
        }
        switch (log_level) {
            case 'debug':
            case FmLogLevels.Debug:
                levelColor = 'white';
                levelName = 'Debug';
                break;
            case 'info':
            case FmLogLevels.Info:
                levelColor = 'green';
                levelName = 'Info';
                break;
            case 'warn':
            case FmLogLevels.Warn:
                levelColor = 'yellow';
                levelName = 'Warn';
                break;
            case 'error':
            case FmLogLevels.Error:
                levelColor = 'red';
                levelName = 'Error';
                break;
            case 'fatal':
            case FmLogLevels.Fatal:
                levelColor = 'purple';
                levelName = 'Fatal';
                break;
        }
        console.log(`FM LOGGER %c[${levelName}]: `, `color: ${levelColor}`, data);
        if (send_to_api) {
            this._reportApi([
                {
                    log_level: levelName,
                    error: data,
                    app: this.appErrors,
                    navigator: this.navigatorErrors,
                    type: FmErrorTypeEnum.CUSTOM_LOGGING,
                    app_name: this.appName,
                },
            ]);
        }
    }
    debug(data) {
        this.logReport(FmLogLevels.Debug, data);
    }
    log(data) {
        this.logReport(FmLogLevels.Info, data);
    }
    info(data) {
        this.logReport(FmLogLevels.Info, data);
    }
    warn(data) {
        this.logReport(FmLogLevels.Warn, data);
    }
    err(data) {
        this.logReport(FmLogLevels.Error, data);
    }
    fatal(data) {
        this.logReport(FmLogLevels.Fatal, data);
    }
    get _versionVerUrl() {
        let url = this.config?.versionVerUrl ? this._rtrim(this.config.versionVerUrl, '/') : '';
        if (url && url !== '') {
            url = `${url}/`;
        }
        return url;
    }
    _rtrim(str, chr) {
        const rgxtrim = !chr ? new RegExp('\\s+$') : new RegExp(chr + '+$');
        return str.replace(rgxtrim, '');
    }
};
FmErrorHandler = __decorate([
    __param(0, Inject(FM_ERROR_CONFIG))
], FmErrorHandler);

class FmErrorHandlerModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('FmErrorHandlerModule is already loaded.');
        }
    }
    static forRoot(configs) {
        return {
            ngModule: FmErrorHandlerModule,
            providers: [
                {
                    provide: FM_ERROR_CONFIG,
                    useValue: { ...defaultConfig$1, ...configs } ?? defaultConfig$1,
                },
                {
                    provide: ErrorHandler,
                    useClass: FmErrorHandler,
                    deps: [FM_ERROR_CONFIG],
                },
                {
                    provide: FM_ERROR_HANDLER_CLASS,
                    useExisting: forwardRef(() => ErrorHandler),
                    deps: [FM_ERROR_CONFIG],
                },
            ],
        };
    }
}
FmErrorHandlerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmErrorHandlerModule, deps: [{ token: FmErrorHandlerModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule });
FmErrorHandlerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: FmErrorHandlerModule, imports: [CommonModule] });
FmErrorHandlerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmErrorHandlerModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmErrorHandlerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                }]
        }], ctorParameters: function () { return [{ type: FmErrorHandlerModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; } });

const defaultConfig = {
    counterTime: 65,
    debugTimer: false,
};

const FM_TIMER_CONFIG = new InjectionToken('FM_TIMER_CONFIG', {
    providedIn: 'root',
    factory: () => defaultConfig,
});

var DialogEventTypes;
(function (DialogEventTypes) {
    DialogEventTypes["RENEW"] = "RENEW";
    DialogEventTypes["LOGOUT"] = "LOGOUT";
})(DialogEventTypes || (DialogEventTypes = {}));

class FmTimerService {
    constructor(_matDialog, _configs) {
        this._matDialog = _matDialog;
        this._configs = _configs;
        /**
         * Counter time in seconds
         *
         * * Lifetime of session in seconds default 1 hour.
         */
        this.jwtLifeTime = 3600;
        /**
         * Counter dialog time in seconds
         *
         * * If the session has 1 hour of lifetime
         * * 90 seconds before expires display a dialog with
         * * a counter of 1 minute and when the dialog closes
         * * 30 seconds left to save pending tasks bedore log the session out.
         */
        this.startDialogTime = 90;
        /**
         * Time to save pending tasks before session expires.
         *
         * * Outer time in seconds
         */
        this.outerTime = 30;
        this.dialogIsOpen = false;
        this.counter$ = new BehaviorSubject(0);
        this.dialogEvents$ = new BehaviorSubject(null);
        Object.assign(this, this._configs);
    }
    startCounter(ignoreDialog = false) {
        if (this.dialogIsOpen && !ignoreDialog) {
            return;
        }
        this.stopCounter();
        this.timer$ = timer(0, 1000).pipe(take(this.jwtLifeTime + 1), map$1((n) => this.jwtLifeTime - n));
        this._startSubscription();
    }
    stopCounter() {
        if (this.sub$ && !this.sub$.closed) {
            this.sub$.unsubscribe();
            this.counter$.next(0);
            return true;
        }
        return false;
    }
    _startSubscription() {
        this.sub$ = this.timer$?.subscribe((n) => {
            this.counter$.next(n);
            if (this._configs?.debugTimer) {
                console.log(n);
            }
            if (n === this.startDialogTime && !this.dialogIsOpen) {
                this._openTimerDialog();
            }
            if (n === 0) {
                this._matDialog.closeAll();
                this.timer$ = null;
                this.dialogIsOpen = false;
            }
        });
    }
    _openTimerDialog() {
        this.dialogIsOpen = true;
        const dialog = this._matDialog.open(FmTimerDialogComponent, {
            disableClose: true,
            width: '450px',
            height: '230px',
            panelClass: ['freddie-dialog'],
            data: {
                outerTime: this.outerTime,
            },
        });
        dialog
            .afterClosed()
            .pipe(take(1))
            .subscribe((res) => {
            if (res) {
                this.dialogEvents$.next(DialogEventTypes.RENEW);
            }
            else {
                this.dialogEvents$.next(DialogEventTypes.LOGOUT);
                this._matDialog.closeAll();
            }
            this.dialogIsOpen = false;
        });
    }
}
FmTimerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmTimerService, deps: [{ token: i1$1.MatDialog }, { token: FM_TIMER_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
FmTimerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmTimerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmTimerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FM_TIMER_CONFIG]
                }] }]; } });

class FmTimerDialogComponent {
    constructor(_matDialogRef, _fmTimerService, data) {
        this._matDialogRef = _matDialogRef;
        this._fmTimerService = _fmTimerService;
        this.data = data;
        this._fmTimerService.counter$
            .pipe(map$1((value) => value - this.data.outerTime))
            .subscribe((value) => {
            if (value >= 0) {
                this.counter = value;
            }
            else {
                this._matDialogRef.close(false);
            }
        });
    }
    resetTimer() {
        this._fmTimerService.startCounter(true);
        this._matDialogRef.close(true);
    }
}
FmTimerDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmTimerDialogComponent, deps: [{ token: i1$1.MatDialogRef }, { token: FmTimerService }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
FmTimerDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: FmTimerDialogComponent, selector: "app-fm-timer-dialog", ngImport: i0, template: "<ng-container>\n    <h2 mat-dialog-title>\n        You session will expire\n    </h2>\n\n    <mat-dialog-content class=\"mat-typography\">\n        <h3>Your session will be logged out in <strong>{{ counter }}</strong> seconds.</h3>\n        <p>Do you want to keep logged in?</p>\n    </mat-dialog-content>\n\n    <mat-dialog-actions align=\"end\">\n        <button\n            mat-button\n            mat-dialog-close>\n            No\n        </button>\n        <button\n            cdkFocusInitial\n            mat-raised-button\n            color=\"primary\"\n            (click)=\"resetTimer()\">\n            yes\n        </button>\n    </mat-dialog-actions>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmTimerDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-fm-timer-dialog', template: "<ng-container>\n    <h2 mat-dialog-title>\n        You session will expire\n    </h2>\n\n    <mat-dialog-content class=\"mat-typography\">\n        <h3>Your session will be logged out in <strong>{{ counter }}</strong> seconds.</h3>\n        <p>Do you want to keep logged in?</p>\n    </mat-dialog-content>\n\n    <mat-dialog-actions align=\"end\">\n        <button\n            mat-button\n            mat-dialog-close>\n            No\n        </button>\n        <button\n            cdkFocusInitial\n            mat-raised-button\n            color=\"primary\"\n            (click)=\"resetTimer()\">\n            yes\n        </button>\n    </mat-dialog-actions>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: FmTimerService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

class FmTimerV2DialogComponent {
    constructor(_matDialogRef, _fmTimerService) {
        this._matDialogRef = _matDialogRef;
        this._fmTimerService = _fmTimerService;
        this._fmTimerService.counter$
            .subscribe((value) => {
            if (value >= 0) {
                this.counter = value;
                if (value === 0) {
                    this._matDialogRef.close(false);
                }
            }
            else {
                this._matDialogRef.close(false);
            }
        });
    }
    resetTimer() {
        this._fmTimerService.startCounter(true);
        this._matDialogRef.close(true);
    }
}
FmTimerV2DialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmTimerV2DialogComponent, deps: [{ token: i1$1.MatDialogRef }, { token: FmTimerV2Service }], target: i0.ɵɵFactoryTarget.Component });
FmTimerV2DialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: FmTimerV2DialogComponent, selector: "app-fm-timer-v2-dialog", ngImport: i0, template: "<ng-container>\n    <h2 mat-dialog-title>\n        You session will expire\n    </h2>\n\n    <mat-dialog-content class=\"mat-typography\">\n        <h3>Your session will be logged out in <strong>{{ counter }}</strong> seconds.</h3>\n        <p>Do you want to keep logged in?</p>\n    </mat-dialog-content>\n\n    <mat-dialog-actions align=\"end\">\n        <button\n            mat-button\n            mat-dialog-close>\n            No\n        </button>\n        <button\n            cdkFocusInitial\n            mat-raised-button\n            color=\"primary\"\n            (click)=\"resetTimer()\">\n            yes\n        </button>\n    </mat-dialog-actions>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmTimerV2DialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-fm-timer-v2-dialog', template: "<ng-container>\n    <h2 mat-dialog-title>\n        You session will expire\n    </h2>\n\n    <mat-dialog-content class=\"mat-typography\">\n        <h3>Your session will be logged out in <strong>{{ counter }}</strong> seconds.</h3>\n        <p>Do you want to keep logged in?</p>\n    </mat-dialog-content>\n\n    <mat-dialog-actions align=\"end\">\n        <button\n            mat-button\n            mat-dialog-close>\n            No\n        </button>\n        <button\n            cdkFocusInitial\n            mat-raised-button\n            color=\"primary\"\n            (click)=\"resetTimer()\">\n            yes\n        </button>\n    </mat-dialog-actions>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: FmTimerV2Service }]; } });

class FmTimerV2Service {
    constructor(_matDialog, _configs) {
        this._matDialog = _matDialog;
        this._configs = _configs;
        /**
         * Counter time in seconds
         *
         * * Lifetime of session in seconds default 1 hour.
         */
        this.counterTime = 65;
        /**
         * Counter to decrease until zero.
         */
        this.counter = 0;
        /**
         * Mat dialog events state.
         */
        this.dialogEvents$ = new BehaviorSubject(null);
        /**
         * Dialog open state.
         */
        this.dialogIsOpen = false;
        /**
         * Counter to display in dialog.
         */
        this.counter$ = new BehaviorSubject(0);
        Object.assign(this, this._configs);
    }
    startCounter(ignoreDialog = false) {
        if (this.dialogIsOpen && !ignoreDialog) {
            return;
        }
        this.stopCounter();
        this.counter = this.counterTime;
        this.timer = setInterval(this._counterCallback.bind(this), 1000);
    }
    stopCounter() {
        if (this.timer) {
            clearInterval(this.timer);
            this.counter$.next(0);
            this.dialogIsOpen = false;
            return true;
        }
        return false;
    }
    _counterCallback() {
        this.counter--;
        this.counter$.next(this.counter);
        if (this._configs?.debugTimer) {
            console.log(this.counter);
        }
        if (!this.dialogIsOpen) {
            this._openTimerDialog.call(this);
        }
        if (this.counter === 0) {
            // this._matDialog.closeAll();
            // this.closeDialog();
            clearInterval(this.timer);
            this.dialogIsOpen = false;
        }
    }
    closeDialog() {
        if (this.dialog) {
            this.dialog.close(null);
        }
    }
    _openTimerDialog() {
        this.dialogIsOpen = true;
        this.dialog = this._matDialog.open(FmTimerV2DialogComponent, {
            disableClose: true,
            width: '450px',
            height: '230px',
            panelClass: ['freddie-dialog'],
        });
        this.dialog
            .afterClosed()
            .pipe(take(1))
            .subscribe((res) => {
            if (res === null) {
                // this._matDialog.closeAll();
                // this.closeDialog();
            }
            else if (res) {
                this.dialogEvents$.next(DialogEventTypes.RENEW);
            }
            else {
                this.dialogEvents$.next(DialogEventTypes.LOGOUT);
                // this._matDialog.closeAll();
                // this.closeDialog();
            }
            this.dialogIsOpen = false;
        });
    }
}
FmTimerV2Service.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmTimerV2Service, deps: [{ token: i1$1.MatDialog }, { token: FM_TIMER_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
FmTimerV2Service.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmTimerV2Service, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmTimerV2Service, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FM_TIMER_CONFIG]
                }] }]; } });

class FmTimerModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('FmTimerModule is already loaded.');
        }
    }
    static forRoot(configs) {
        return {
            ngModule: FmTimerModule,
            providers: [
                {
                    provide: FM_TIMER_CONFIG,
                    useValue: { ...defaultConfig, ...configs } ?? defaultConfig,
                },
            ],
        };
    }
}
FmTimerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmTimerModule, deps: [{ token: FmTimerModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule });
FmTimerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: FmTimerModule, declarations: [FmTimerDialogComponent, FmTimerV2DialogComponent], imports: [CommonModule, MatDialogModule, MatButtonModule], exports: [FmTimerDialogComponent, FmTimerV2DialogComponent] });
FmTimerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmTimerModule, providers: [FmTimerService, FmTimerV2Service], imports: [CommonModule, MatDialogModule, MatButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmTimerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FmTimerDialogComponent, FmTimerV2DialogComponent],
                    imports: [CommonModule, MatDialogModule, MatButtonModule],
                    exports: [FmTimerDialogComponent, FmTimerV2DialogComponent],
                    providers: [FmTimerService, FmTimerV2Service],
                }]
        }], ctorParameters: function () { return [{ type: FmTimerModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; } });

var Platforms;
(function (Platforms) {
    Platforms[Platforms["DOCTORS"] = 1] = "DOCTORS";
    Platforms[Platforms["PATIENT"] = 2] = "PATIENT";
    Platforms[Platforms["DISPENSATION"] = 3] = "DISPENSATION";
    Platforms[Platforms["ONBOARDING"] = 4] = "ONBOARDING";
    Platforms[Platforms["REGISTRATION"] = 5] = "REGISTRATION";
})(Platforms || (Platforms = {}));

class FmFormGroup extends UntypedFormGroup {
    constructor(controls, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this._waitAndSubmit = (callback) => {
            if (this.submittingTimeout) {
                clearTimeout(this.submittingTimeout);
            }
            if (this.pending) {
                this.submittingTimeout = setTimeout(this._waitAndSubmit.bind(this, callback), 50);
            }
            else {
                callback.call(this);
            }
        };
    }
    invalidControls() {
        const invalid = [];
        for (const key in this.controls) {
            if (this.controls[key].invalid) {
                invalid.push(key);
            }
        }
        return invalid;
    }
    validateFormGroup(callback = null, errorCallback = null) {
        this.markAllAsTouched();
        for (const name in this.controls) {
            this.controls[name].markAsDirty();
            this.controls[name].updateValueAndValidity({ emitEvent: false });
        }
        if (this.invalid) {
            if (errorCallback) {
                errorCallback(this.invalidControls());
            }
            /* AppInjector.get(AlertService).openErrorSnack(this._errorInvalidField + this.invalidControls().join()); */
            this.scrollIntoInvalidControl();
        }
        if (callback) {
            this._waitAndSubmit(callback);
        }
    }
    scrollIntoInvalidControl() {
        const allInputs = document.querySelectorAll('input, textarea');
        if (allInputs.length) {
            const invalidInput = Array.from(allInputs).find((node) => node.className.includes('ng-invalid'));
            if (invalidInput) {
                invalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }
}

class ProcessedCountryCode {
    constructor() {
        this.allCountries = [{
                'name': 'Afghanistan (‫افغانستان‬‎)',
                'iso2': 'af',
                'dialCode': '93',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'af'
            }, {
                'name': 'Albania (Shqipëri)',
                'iso2': 'al',
                'dialCode': '355',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'al'
            }, {
                'name': 'Algeria (‫الجزائر‬‎)',
                'iso2': 'dz',
                'dialCode': '213',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'dz'
            }, {
                'name': 'American Samoa',
                'iso2': 'as',
                'dialCode': '1684',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'as'
            }, {
                'name': 'Andorra',
                'iso2': 'ad',
                'dialCode': '376',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ad'
            }, {
                'name': 'Angola',
                'iso2': 'ao',
                'dialCode': '244',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ao'
            }, {
                'name': 'Anguilla',
                'iso2': 'ai',
                'dialCode': '1264',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ai'
            }, {
                'name': 'Antigua and Barbuda',
                'iso2': 'ag',
                'dialCode': '1268',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ag'
            }, {
                'name': 'Argentina',
                'iso2': 'ar',
                'dialCode': '54',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ar'
            }, {
                'name': 'Armenia (Հայաստան)',
                'iso2': 'am',
                'dialCode': '374',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'am'
            }, {
                'name': 'Aruba',
                'iso2': 'aw',
                'dialCode': '297',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'aw'
            }, {
                'name': 'Australia',
                'iso2': 'au',
                'dialCode': '61',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'au'
            }, {
                'name': 'Austria (Österreich)',
                'iso2': 'at',
                'dialCode': '43',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'at'
            }, {
                'name': 'Azerbaijan (Azərbaycan)',
                'iso2': 'az',
                'dialCode': '994',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'az'
            }, {
                'name': 'Bahamas',
                'iso2': 'bs',
                'dialCode': '1242',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bs'
            }, {
                'name': 'Bahrain (‫البحرين‬‎)',
                'iso2': 'bh',
                'dialCode': '973',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bh'
            }, {
                'name': 'Bangladesh (বাংলাদেশ)',
                'iso2': 'bd',
                'dialCode': '880',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bd'
            }, {
                'name': 'Barbados',
                'iso2': 'bb',
                'dialCode': '1246',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bb'
            }, {
                'name': 'Belarus (Беларусь)',
                'iso2': 'by',
                'dialCode': '375',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'by'
            }, {
                'name': 'Belgium (België)',
                'iso2': 'be',
                'dialCode': '32',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'be'
            }, {
                'name': 'Belize',
                'iso2': 'bz',
                'dialCode': '501',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bz'
            }, {
                'name': 'Benin (Bénin)',
                'iso2': 'bj',
                'dialCode': '229',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bj'
            }, {
                'name': 'Bermuda',
                'iso2': 'bm',
                'dialCode': '1441',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bm'
            }, {
                'name': 'Bhutan (འབྲུག)',
                'iso2': 'bt',
                'dialCode': '975',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bt'
            }, {
                'name': 'Bolivia',
                'iso2': 'bo',
                'dialCode': '591',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bo'
            }, {
                'name': 'Bosnia and Herzegovina (Босна и Херцеговина)',
                'iso2': 'ba',
                'dialCode': '387',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ba'
            }, {
                'name': 'Botswana',
                'iso2': 'bw',
                'dialCode': '267',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bw'
            }, {
                'name': 'Brazil (Brasil)',
                'iso2': 'br',
                'dialCode': '55',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'br'
            }, {
                'name': 'British Indian Ocean Territory',
                'iso2': 'io',
                'dialCode': '246',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'io'
            }, {
                'name': 'British Virgin Islands',
                'iso2': 'vg',
                'dialCode': '1284',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'vg'
            }, {
                'name': 'Brunei',
                'iso2': 'bn',
                'dialCode': '673',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bn'
            }, {
                'name': 'Bulgaria (България)',
                'iso2': 'bg',
                'dialCode': '359',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bg'
            }, {
                'name': 'Burkina Faso',
                'iso2': 'bf',
                'dialCode': '226',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bf'
            }, {
                'name': 'Burundi (Uburundi)',
                'iso2': 'bi',
                'dialCode': '257',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'bi'
            }, {
                'name': 'Cambodia (កម្ពុជា)',
                'iso2': 'kh',
                'dialCode': '855',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'kh'
            }, {
                'name': 'Cameroon (Cameroun)',
                'iso2': 'cm',
                'dialCode': '237',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'cm'
            }, {
                'name': 'Canada',
                'iso2': 'ca',
                'dialCode': '1',
                'priority': 1,
                'areaCode': null,
                'flagClass': 'ca'
            }, {
                'name': 'Cape Verde (Kabu Verdi)',
                'iso2': 'cv',
                'dialCode': '238',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'cv'
            }, {
                'name': 'Caribbean Netherlands',
                'iso2': 'bq',
                'dialCode': '599',
                'priority': 1,
                'areaCode': null,
                'flagClass': 'bq'
            }, {
                'name': 'Cayman Islands',
                'iso2': 'ky',
                'dialCode': '1345',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ky'
            }, {
                'name': 'Central African Republic (République centrafricaine)',
                'iso2': 'cf',
                'dialCode': '236',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'cf'
            }, {
                'name': 'Chad (Tchad)',
                'iso2': 'td',
                'dialCode': '235',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'td'
            }, {
                'name': 'Chile',
                'iso2': 'cl',
                'dialCode': '56',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'cl'
            }, {
                'name': 'China (中国)',
                'iso2': 'cn',
                'dialCode': '86',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'cn'
            }, {
                'name': 'Christmas Island',
                'iso2': 'cx',
                'dialCode': '61',
                'priority': 2,
                'areaCode': null,
                'flagClass': 'cx'
            }, {
                'name': 'Cocos (Keeling) Islands',
                'iso2': 'cc',
                'dialCode': '61',
                'priority': 1,
                'areaCode': null,
                'flagClass': 'cc'
            }, {
                'name': 'Colombia',
                'iso2': 'co',
                'dialCode': '57',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'co'
            }, {
                'name': 'Comoros (‫جزر القمر‬‎)',
                'iso2': 'km',
                'dialCode': '269',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'km'
            }, {
                'name': 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
                'iso2': 'cd',
                'dialCode': '243',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'cd'
            }, {
                'name': 'Congo (Republic) (Congo-Brazzaville)',
                'iso2': 'cg',
                'dialCode': '242',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'cg'
            }, {
                'name': 'Cook Islands',
                'iso2': 'ck',
                'dialCode': '682',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ck'
            }, {
                'name': 'Costa Rica',
                'iso2': 'cr',
                'dialCode': '506',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'cr'
            }, {
                'name': 'Côte d’Ivoire',
                'iso2': 'ci',
                'dialCode': '225',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ci'
            }, {
                'name': 'Croatia (Hrvatska)',
                'iso2': 'hr',
                'dialCode': '385',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'hr'
            }, {
                'name': 'Cuba',
                'iso2': 'cu',
                'dialCode': '53',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'cu'
            }, {
                'name': 'Curaçao',
                'iso2': 'cw',
                'dialCode': '599',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'cw'
            }, {
                'name': 'Cyprus (Κύπρος)',
                'iso2': 'cy',
                'dialCode': '357',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'cy'
            }, {
                'name': 'Czech Republic (Česká republika)',
                'iso2': 'cz',
                'dialCode': '420',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'cz'
            }, {
                'name': 'Denmark (Danmark)',
                'iso2': 'dk',
                'dialCode': '45',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'dk'
            }, {
                'name': 'Djibouti',
                'iso2': 'dj',
                'dialCode': '253',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'dj'
            }, {
                'name': 'Dominica',
                'iso2': 'dm',
                'dialCode': '1767',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'dm'
            }, {
                'name': 'Dominican Republic (República Dominicana)',
                'iso2': 'do',
                'dialCode': '1',
                'priority': 2,
                'areaCode': null,
                'flagClass': 'do'
            }, {
                'name': 'Ecuador',
                'iso2': 'ec',
                'dialCode': '593',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ec'
            }, {
                'name': 'Egypt (‫مصر‬‎)',
                'iso2': 'eg',
                'dialCode': '20',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'eg'
            }, {
                'name': 'El Salvador',
                'iso2': 'sv',
                'dialCode': '503',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sv'
            }, {
                'name': 'Equatorial Guinea (Guinea Ecuatorial)',
                'iso2': 'gq',
                'dialCode': '240',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gq'
            }, {
                'name': 'Eritrea',
                'iso2': 'er',
                'dialCode': '291',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'er'
            }, {
                'name': 'Estonia (Eesti)',
                'iso2': 'ee',
                'dialCode': '372',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ee'
            }, {
                'name': 'Ethiopia',
                'iso2': 'et',
                'dialCode': '251',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'et'
            }, {
                'name': 'Falkland Islands (Islas Malvinas)',
                'iso2': 'fk',
                'dialCode': '500',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'fk'
            }, {
                'name': 'Faroe Islands (Føroyar)',
                'iso2': 'fo',
                'dialCode': '298',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'fo'
            }, {
                'name': 'Fiji',
                'iso2': 'fj',
                'dialCode': '679',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'fj'
            }, {
                'name': 'Finland (Suomi)',
                'iso2': 'fi',
                'dialCode': '358',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'fi'
            }, {
                'name': 'France',
                'iso2': 'fr',
                'dialCode': '33',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'fr'
            }, {
                'name': 'French Guiana (Guyane française)',
                'iso2': 'gf',
                'dialCode': '594',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gf'
            }, {
                'name': 'French Polynesia (Polynésie française)',
                'iso2': 'pf',
                'dialCode': '689',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'pf'
            }, {
                'name': 'Gabon',
                'iso2': 'ga',
                'dialCode': '241',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ga'
            }, {
                'name': 'Gambia',
                'iso2': 'gm',
                'dialCode': '220',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gm'
            }, {
                'name': 'Georgia (საქართველო)',
                'iso2': 'ge',
                'dialCode': '995',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ge'
            }, {
                'name': 'Germany (Deutschland)',
                'iso2': 'de',
                'dialCode': '49',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'de'
            }, {
                'name': 'Ghana (Gaana)',
                'iso2': 'gh',
                'dialCode': '233',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gh'
            }, {
                'name': 'Gibraltar',
                'iso2': 'gi',
                'dialCode': '350',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gi'
            }, {
                'name': 'Greece (Ελλάδα)',
                'iso2': 'gr',
                'dialCode': '30',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gr'
            }, {
                'name': 'Greenland (Kalaallit Nunaat)',
                'iso2': 'gl',
                'dialCode': '299',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gl'
            }, {
                'name': 'Grenada',
                'iso2': 'gd',
                'dialCode': '1473',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gd'
            }, {
                'name': 'Guadeloupe',
                'iso2': 'gp',
                'dialCode': '590',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gp'
            }, {
                'name': 'Guam',
                'iso2': 'gu',
                'dialCode': '1671',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gu'
            }, {
                'name': 'Guatemala',
                'iso2': 'gt',
                'dialCode': '502',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gt'
            }, {
                'name': 'Guernsey',
                'iso2': 'gg',
                'dialCode': '44',
                'priority': 1,
                'areaCode': null,
                'flagClass': 'gg'
            }, {
                'name': 'Guinea (Guinée)',
                'iso2': 'gn',
                'dialCode': '224',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gn'
            }, {
                'name': 'Guinea-Bissau (Guiné Bissau)',
                'iso2': 'gw',
                'dialCode': '245',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gw'
            }, {
                'name': 'Guyana',
                'iso2': 'gy',
                'dialCode': '592',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gy'
            }, {
                'name': 'Haiti',
                'iso2': 'ht',
                'dialCode': '509',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ht'
            }, {
                'name': 'Honduras',
                'iso2': 'hn',
                'dialCode': '504',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'hn'
            }, {
                'name': 'Hong Kong (香港)',
                'iso2': 'hk',
                'dialCode': '852',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'hk'
            }, {
                'name': 'Hungary (Magyarország)',
                'iso2': 'hu',
                'dialCode': '36',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'hu'
            }, {
                'name': 'Iceland (Ísland)',
                'iso2': 'is',
                'dialCode': '354',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'is'
            }, {
                'name': 'India (भारत)',
                'iso2': 'in',
                'dialCode': '91',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'in'
            }, {
                'name': 'Indonesia',
                'iso2': 'id',
                'dialCode': '62',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'id'
            }, {
                'name': 'Iran (‫ایران‬‎)',
                'iso2': 'ir',
                'dialCode': '98',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ir'
            }, {
                'name': 'Iraq (‫العراق‬‎)',
                'iso2': 'iq',
                'dialCode': '964',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'iq'
            }, {
                'name': 'Ireland',
                'iso2': 'ie',
                'dialCode': '353',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ie'
            }, {
                'name': 'Isle of Man',
                'iso2': 'im',
                'dialCode': '44',
                'priority': 2,
                'areaCode': null,
                'flagClass': 'im'
            }, {
                'name': 'Israel (‫ישראל‬‎)',
                'iso2': 'il',
                'dialCode': '972',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'il'
            }, {
                'name': 'Italy (Italia)',
                'iso2': 'it',
                'dialCode': '39',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'it'
            }, {
                'name': 'Jamaica',
                'iso2': 'jm',
                'dialCode': '1876',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'jm'
            }, {
                'name': 'Japan (日本)',
                'iso2': 'jp',
                'dialCode': '81',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'jp'
            }, {
                'name': 'Jersey',
                'iso2': 'je',
                'dialCode': '44',
                'priority': 3,
                'areaCode': null,
                'flagClass': 'je'
            }, {
                'name': 'Jordan (‫الأردن‬‎)',
                'iso2': 'jo',
                'dialCode': '962',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'jo'
            }, {
                'name': 'Kazakhstan (Казахстан)',
                'iso2': 'kz',
                'dialCode': '7',
                'priority': 1,
                'areaCode': null,
                'flagClass': 'kz'
            }, {
                'name': 'Kenya',
                'iso2': 'ke',
                'dialCode': '254',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ke'
            }, {
                'name': 'Kiribati',
                'iso2': 'ki',
                'dialCode': '686',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ki'
            }, {
                'name': 'Kosovo',
                'iso2': 'xk',
                'dialCode': '383',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'xk'
            }, {
                'name': 'Kuwait (‫الكويت‬‎)',
                'iso2': 'kw',
                'dialCode': '965',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'kw'
            }, {
                'name': 'Kyrgyzstan (Кыргызстан)',
                'iso2': 'kg',
                'dialCode': '996',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'kg'
            }, {
                'name': 'Laos (ລາວ)',
                'iso2': 'la',
                'dialCode': '856',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'la'
            }, {
                'name': 'Latvia (Latvija)',
                'iso2': 'lv',
                'dialCode': '371',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'lv'
            }, {
                'name': 'Lebanon (‫لبنان‬‎)',
                'iso2': 'lb',
                'dialCode': '961',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'lb'
            }, {
                'name': 'Lesotho',
                'iso2': 'ls',
                'dialCode': '266',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ls'
            }, {
                'name': 'Liberia',
                'iso2': 'lr',
                'dialCode': '231',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'lr'
            }, {
                'name': 'Libya (‫ليبيا‬‎)',
                'iso2': 'ly',
                'dialCode': '218',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ly'
            }, {
                'name': 'Liechtenstein',
                'iso2': 'li',
                'dialCode': '423',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'li'
            }, {
                'name': 'Lithuania (Lietuva)',
                'iso2': 'lt',
                'dialCode': '370',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'lt'
            }, {
                'name': 'Luxembourg',
                'iso2': 'lu',
                'dialCode': '352',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'lu'
            }, {
                'name': 'Macau (澳門)',
                'iso2': 'mo',
                'dialCode': '853',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mo'
            }, {
                'name': 'Macedonia (FYROM) (Македонија)',
                'iso2': 'mk',
                'dialCode': '389',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mk'
            }, {
                'name': 'Madagascar (Madagasikara)',
                'iso2': 'mg',
                'dialCode': '261',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mg'
            }, {
                'name': 'Malawi',
                'iso2': 'mw',
                'dialCode': '265',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mw'
            }, {
                'name': 'Malaysia',
                'iso2': 'my',
                'dialCode': '60',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'my'
            }, {
                'name': 'Maldives',
                'iso2': 'mv',
                'dialCode': '960',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mv'
            }, {
                'name': 'Mali',
                'iso2': 'ml',
                'dialCode': '223',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ml'
            }, {
                'name': 'Malta',
                'iso2': 'mt',
                'dialCode': '356',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mt'
            }, {
                'name': 'Marshall Islands',
                'iso2': 'mh',
                'dialCode': '692',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mh'
            }, {
                'name': 'Martinique',
                'iso2': 'mq',
                'dialCode': '596',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mq'
            }, {
                'name': 'Mauritania (‫موريتانيا‬‎)',
                'iso2': 'mr',
                'dialCode': '222',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mr'
            }, {
                'name': 'Mauritius (Moris)',
                'iso2': 'mu',
                'dialCode': '230',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mu'
            }, {
                'name': 'Mayotte',
                'iso2': 'yt',
                'dialCode': '262',
                'priority': 1,
                'areaCode': null,
                'flagClass': 'yt'
            }, {
                'name': 'Mexico (México)',
                'iso2': 'mx',
                'dialCode': '52',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mx'
            }, {
                'name': 'Micronesia',
                'iso2': 'fm',
                'dialCode': '691',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'fm'
            }, {
                'name': 'Moldova (Republica Moldova)',
                'iso2': 'md',
                'dialCode': '373',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'md'
            }, {
                'name': 'Monaco',
                'iso2': 'mc',
                'dialCode': '377',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mc'
            }, {
                'name': 'Mongolia (Монгол)',
                'iso2': 'mn',
                'dialCode': '976',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mn'
            }, {
                'name': 'Montenegro (Crna Gora)',
                'iso2': 'me',
                'dialCode': '382',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'me'
            }, {
                'name': 'Montserrat',
                'iso2': 'ms',
                'dialCode': '1664',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ms'
            }, {
                'name': 'Morocco (‫المغرب‬‎)',
                'iso2': 'ma',
                'dialCode': '212',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ma'
            }, {
                'name': 'Mozambique (Moçambique)',
                'iso2': 'mz',
                'dialCode': '258',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mz'
            }, {
                'name': 'Myanmar (Burma) (မြန်မာ)',
                'iso2': 'mm',
                'dialCode': '95',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mm'
            }, {
                'name': 'Namibia (Namibië)',
                'iso2': 'na',
                'dialCode': '264',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'na'
            }, {
                'name': 'Nauru',
                'iso2': 'nr',
                'dialCode': '674',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'nr'
            }, {
                'name': 'Nepal (नेपाल)',
                'iso2': 'np',
                'dialCode': '977',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'np'
            }, {
                'name': 'Netherlands (Nederland)',
                'iso2': 'nl',
                'dialCode': '31',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'nl'
            }, {
                'name': 'New Caledonia (Nouvelle-Calédonie)',
                'iso2': 'nc',
                'dialCode': '687',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'nc'
            }, {
                'name': 'New Zealand',
                'iso2': 'nz',
                'dialCode': '64',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'nz'
            }, {
                'name': 'Nicaragua',
                'iso2': 'ni',
                'dialCode': '505',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ni'
            }, {
                'name': 'Niger (Nijar)',
                'iso2': 'ne',
                'dialCode': '227',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ne'
            }, {
                'name': 'Nigeria',
                'iso2': 'ng',
                'dialCode': '234',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ng'
            }, {
                'name': 'Niue',
                'iso2': 'nu',
                'dialCode': '683',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'nu'
            }, {
                'name': 'Norfolk Island',
                'iso2': 'nf',
                'dialCode': '672',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'nf'
            }, {
                'name': 'North Korea (조선 민주주의 인민 공화국)',
                'iso2': 'kp',
                'dialCode': '850',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'kp'
            }, {
                'name': 'Northern Mariana Islands',
                'iso2': 'mp',
                'dialCode': '1670',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'mp'
            }, {
                'name': 'Norway (Norge)',
                'iso2': 'no',
                'dialCode': '47',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'no'
            }, {
                'name': 'Oman (‫عُمان‬‎)',
                'iso2': 'om',
                'dialCode': '968',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'om'
            }, {
                'name': 'Pakistan (‫پاکستان‬‎)',
                'iso2': 'pk',
                'dialCode': '92',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'pk'
            }, {
                'name': 'Palau',
                'iso2': 'pw',
                'dialCode': '680',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'pw'
            }, {
                'name': 'Palestine (‫فلسطين‬‎)',
                'iso2': 'ps',
                'dialCode': '970',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ps'
            }, {
                'name': 'Panama (Panamá)',
                'iso2': 'pa',
                'dialCode': '507',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'pa'
            }, {
                'name': 'Papua New Guinea',
                'iso2': 'pg',
                'dialCode': '675',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'pg'
            }, {
                'name': 'Paraguay',
                'iso2': 'py',
                'dialCode': '595',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'py'
            }, {
                'name': 'Peru (Perú)',
                'iso2': 'pe',
                'dialCode': '51',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'pe'
            }, {
                'name': 'Philippines',
                'iso2': 'ph',
                'dialCode': '63',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ph'
            }, {
                'name': 'Poland (Polska)',
                'iso2': 'pl',
                'dialCode': '48',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'pl'
            }, {
                'name': 'Portugal',
                'iso2': 'pt',
                'dialCode': '351',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'pt'
            }, {
                'name': 'Puerto Rico',
                'iso2': 'pr',
                'dialCode': '1',
                'priority': 3,
                'areaCode': null,
                'flagClass': 'pr'
            }, {
                'name': 'Qatar (‫قطر‬‎)',
                'iso2': 'qa',
                'dialCode': '974',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'qa'
            }, {
                'name': 'Réunion (La Réunion)',
                'iso2': 're',
                'dialCode': '262',
                'priority': 0,
                'areaCode': null,
                'flagClass': 're'
            }, {
                'name': 'Romania (România)',
                'iso2': 'ro',
                'dialCode': '40',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ro'
            }, {
                'name': 'Russia (Россия)',
                'iso2': 'ru',
                'dialCode': '7',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ru'
            }, {
                'name': 'Rwanda',
                'iso2': 'rw',
                'dialCode': '250',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'rw'
            }, {
                'name': 'Saint Barthélemy (Saint-Barthélemy)',
                'iso2': 'bl',
                'dialCode': '590',
                'priority': 1,
                'areaCode': null,
                'flagClass': 'bl'
            }, {
                'name': 'Saint Helena',
                'iso2': 'sh',
                'dialCode': '290',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sh'
            }, {
                'name': 'Saint Kitts and Nevis',
                'iso2': 'kn',
                'dialCode': '1869',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'kn'
            }, {
                'name': 'Saint Lucia',
                'iso2': 'lc',
                'dialCode': '1758',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'lc'
            }, {
                'name': 'Saint Martin (Saint-Martin (partie française))',
                'iso2': 'mf',
                'dialCode': '590',
                'priority': 2,
                'areaCode': null,
                'flagClass': 'mf'
            }, {
                'name': 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
                'iso2': 'pm',
                'dialCode': '508',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'pm'
            }, {
                'name': 'Saint Vincent and the Grenadines',
                'iso2': 'vc',
                'dialCode': '1784',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'vc'
            }, {
                'name': 'Samoa',
                'iso2': 'ws',
                'dialCode': '685',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ws'
            }, {
                'name': 'San Marino',
                'iso2': 'sm',
                'dialCode': '378',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sm'
            }, {
                'name': 'São Tomé and Príncipe (São Tomé e Príncipe)',
                'iso2': 'st',
                'dialCode': '239',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'st'
            }, {
                'name': 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
                'iso2': 'sa',
                'dialCode': '966',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sa'
            }, {
                'name': 'Senegal (Sénégal)',
                'iso2': 'sn',
                'dialCode': '221',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sn'
            }, {
                'name': 'Serbia (Србија)',
                'iso2': 'rs',
                'dialCode': '381',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'rs'
            }, {
                'name': 'Seychelles',
                'iso2': 'sc',
                'dialCode': '248',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sc'
            }, {
                'name': 'Sierra Leone',
                'iso2': 'sl',
                'dialCode': '232',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sl'
            }, {
                'name': 'Singapore',
                'iso2': 'sg',
                'dialCode': '65',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sg'
            }, {
                'name': 'Sint Maarten',
                'iso2': 'sx',
                'dialCode': '1721',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sx'
            }, {
                'name': 'Slovakia (Slovensko)',
                'iso2': 'sk',
                'dialCode': '421',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sk'
            }, {
                'name': 'Slovenia (Slovenija)',
                'iso2': 'si',
                'dialCode': '386',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'si'
            }, {
                'name': 'Solomon Islands',
                'iso2': 'sb',
                'dialCode': '677',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sb'
            }, {
                'name': 'Somalia (Soomaaliya)',
                'iso2': 'so',
                'dialCode': '252',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'so'
            }, {
                'name': 'South Africa',
                'iso2': 'za',
                'dialCode': '27',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'za'
            }, {
                'name': 'South Korea (대한민국)',
                'iso2': 'kr',
                'dialCode': '82',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'kr'
            }, {
                'name': 'South Sudan (‫جنوب السودان‬‎)',
                'iso2': 'ss',
                'dialCode': '211',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ss'
            }, {
                'name': 'Spain (España)',
                'iso2': 'es',
                'dialCode': '34',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'es'
            }, {
                'name': 'Sri Lanka (ශ්‍රී ලංකාව)',
                'iso2': 'lk',
                'dialCode': '94',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'lk'
            }, {
                'name': 'Sudan (‫السودان‬‎)',
                'iso2': 'sd',
                'dialCode': '249',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sd'
            }, {
                'name': 'Suriname',
                'iso2': 'sr',
                'dialCode': '597',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sr'
            }, {
                'name': 'Svalbard and Jan Mayen',
                'iso2': 'sj',
                'dialCode': '47',
                'priority': 1,
                'areaCode': null,
                'flagClass': 'sj'
            }, {
                'name': 'Swaziland',
                'iso2': 'sz',
                'dialCode': '268',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sz'
            }, {
                'name': 'Sweden (Sverige)',
                'iso2': 'se',
                'dialCode': '46',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'se'
            }, {
                'name': 'Switzerland (Schweiz)',
                'iso2': 'ch',
                'dialCode': '41',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ch'
            }, {
                'name': 'Syria (‫سوريا‬‎)',
                'iso2': 'sy',
                'dialCode': '963',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'sy'
            }, {
                'name': 'Taiwan (台灣)',
                'iso2': 'tw',
                'dialCode': '886',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'tw'
            }, {
                'name': 'Tajikistan',
                'iso2': 'tj',
                'dialCode': '992',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'tj'
            }, {
                'name': 'Tanzania',
                'iso2': 'tz',
                'dialCode': '255',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'tz'
            }, {
                'name': 'Thailand (ไทย)',
                'iso2': 'th',
                'dialCode': '66',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'th'
            }, {
                'name': 'Timor-Leste',
                'iso2': 'tl',
                'dialCode': '670',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'tl'
            }, {
                'name': 'Togo',
                'iso2': 'tg',
                'dialCode': '228',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'tg'
            }, {
                'name': 'Tokelau',
                'iso2': 'tk',
                'dialCode': '690',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'tk'
            }, {
                'name': 'Tonga',
                'iso2': 'to',
                'dialCode': '676',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'to'
            }, {
                'name': 'Trinidad and Tobago',
                'iso2': 'tt',
                'dialCode': '1868',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'tt'
            }, {
                'name': 'Tunisia (‫تونس‬‎)',
                'iso2': 'tn',
                'dialCode': '216',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'tn'
            }, {
                'name': 'Turkey (Türkiye)',
                'iso2': 'tr',
                'dialCode': '90',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'tr'
            }, {
                'name': 'Turkmenistan',
                'iso2': 'tm',
                'dialCode': '993',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'tm'
            }, {
                'name': 'Turks and Caicos Islands',
                'iso2': 'tc',
                'dialCode': '1649',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'tc'
            }, {
                'name': 'Tuvalu',
                'iso2': 'tv',
                'dialCode': '688',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'tv'
            }, {
                'name': 'U.S. Virgin Islands',
                'iso2': 'vi',
                'dialCode': '1340',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'vi'
            }, {
                'name': 'Uganda',
                'iso2': 'ug',
                'dialCode': '256',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ug'
            }, {
                'name': 'Ukraine (Україна)',
                'iso2': 'ua',
                'dialCode': '380',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ua'
            }, {
                'name': 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
                'iso2': 'ae',
                'dialCode': '971',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ae'
            }, {
                'name': 'United Kingdom',
                'iso2': 'gb',
                'dialCode': '44',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'gb'
            }, {
                'name': 'United States',
                'iso2': 'us',
                'dialCode': '1',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'us'
            }, {
                'name': 'Uruguay',
                'iso2': 'uy',
                'dialCode': '598',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'uy'
            }, {
                'name': 'Uzbekistan (Oʻzbekiston)',
                'iso2': 'uz',
                'dialCode': '998',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'uz'
            }, {
                'name': 'Vanuatu',
                'iso2': 'vu',
                'dialCode': '678',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'vu'
            }, {
                'name': 'Vatican City (Città del Vaticano)',
                'iso2': 'va',
                'dialCode': '39',
                'priority': 1,
                'areaCode': null,
                'flagClass': 'va'
            }, {
                'name': 'Venezuela',
                'iso2': 've',
                'dialCode': '58',
                'priority': 0,
                'areaCode': null,
                'flagClass': 've'
            }, {
                'name': 'Vietnam (Việt Nam)',
                'iso2': 'vn',
                'dialCode': '84',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'vn'
            }, {
                'name': 'Wallis and Futuna',
                'iso2': 'wf',
                'dialCode': '681',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'wf'
            }, {
                'name': 'Western Sahara (‫الصحراء الغربية‬‎)',
                'iso2': 'eh',
                'dialCode': '212',
                'priority': 1,
                'areaCode': null,
                'flagClass': 'eh'
            }, {
                'name': 'Yemen (‫اليمن‬‎)',
                'iso2': 'ye',
                'dialCode': '967',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'ye'
            }, {
                'name': 'Zambia',
                'iso2': 'zm',
                'dialCode': '260',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'zm'
            }, {
                'name': 'Zimbabwe',
                'iso2': 'zw',
                'dialCode': '263',
                'priority': 0,
                'areaCode': null,
                'flagClass': 'zw'
            }, {
                'name': 'Åland Islands',
                'iso2': 'ax',
                'dialCode': '358',
                'priority': 1,
                'areaCode': null,
                'flagClass': 'ax'
            }];
    }
}
ProcessedCountryCode.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: ProcessedCountryCode, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ProcessedCountryCode.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: ProcessedCountryCode });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: ProcessedCountryCode, decorators: [{
            type: Injectable
        }] });

class Base {
    constructor() {
        this.subscriptions = new Subscription();
        this.submitting$ = new BehaviorSubject(false);
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
Base.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: Base, deps: [], target: i0.ɵɵFactoryTarget.Component });
Base.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: Base, selector: "ng-component", ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: Base, decorators: [{
            type: Component,
            args: [{
                    template: '',
                }]
        }], ctorParameters: function () { return []; } });

class FmProgressLoaderDirective {
    constructor(_el) {
        this._el = _el;
        this.isLoading = null;
        this._defaultContent = null;
        this._parentContainer = null;
        this._spinnerElement = null;
        this._inputColor = '#375fe6';
        this._buttonColor = '#ffffff';
    }
    ngAfterViewInit() {
        this._initParent();
    }
    ngOnChanges() {
        if (this.isLoading) {
            this._initLoader();
        }
        else {
            this._removeLoader();
        }
    }
    ngOnDestroy() {
        this._removeLoader();
    }
    _initLoader() {
        if (this.isLoading) {
            if (this._parentContainer) {
                this._parentContainer.appendChild((this._spinnerElement = this._createSpinner()));
            }
            else {
                setTimeout(this._initLoader.bind(this), 10);
            }
        }
    }
    _removeLoader() {
        const container = this._el.nativeElement;
        if (this._defaultContent) {
            container.innerHTML = this._defaultContent;
            this._defaultContent = null;
        }
        if (this._spinnerElement) {
            this._spinnerElement.remove();
        }
    }
    _initParent() {
        if (!this._parentContainer) {
            const container = this._el.nativeElement;
            this._parentContainer = document.createElement('div');
            this._parentContainer.style.position = 'relative';
            this._parentContainer.style.display = 'flex';
            container.parentNode?.replaceChild(this._parentContainer, container);
            this._parentContainer.appendChild(container);
        }
    }
    _createSpinner() {
        const container = this._el.nativeElement;
        let color = '#ffffff';
        const element = document.createElement('div');
        if (this._el.nativeElement.tagName === 'INPUT') {
            element.style.cssText = `
				display: inline-block;
				width: 20px;
				height: 20px;
				transform: translate(-50%);
            `;
            color = this._inputColor;
        }
        else {
            element.style.top = '50%';
            element.style.left = '50%';
            element.style.transform = '';
            element.style.cssText = `
				position: absolute;
				display: inline-block;
				width: 20px;
				height: 20px;
				left: 50%;
                top: 50%;
				transform: translate(-50%,-50%);
            `;
            this._defaultContent = container.innerHTML;
            container.innerHTML = '';
            color = this._buttonColor;
        }
        const innerDiv = document.createElement('div');
        innerDiv.style.cssText = `
			display: block;
			width: 100%;
			height: 100%;
			border-radius: 50%;
			border: 2px solid ${color};
			border-color: ${color} transparent ${color} transparent;
			animation: fm-spinner 1.2s linear infinite;
        `;
        element.appendChild(innerDiv);
        return element;
    }
}
FmProgressLoaderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmProgressLoaderDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
FmProgressLoaderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.6", type: FmProgressLoaderDirective, selector: "[fmLoader]", inputs: { isLoading: "isLoading" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmProgressLoaderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fmLoader]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { isLoading: [{
                type: Input
            }] } });

class FmLoaderDirectiveModule {
}
FmLoaderDirectiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmLoaderDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FmLoaderDirectiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: FmLoaderDirectiveModule, declarations: [FmProgressLoaderDirective], imports: [CommonModule], exports: [FmProgressLoaderDirective] });
FmLoaderDirectiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmLoaderDirectiveModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmLoaderDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FmProgressLoaderDirective],
                    imports: [CommonModule],
                    exports: [FmProgressLoaderDirective],
                }]
        }] });

class ValidatorService {
    constructor(configs, _http) {
        this.configs = configs;
        this._http = _http;
    }
    /**
     * Validator endpoint
     *
     * @link api/v2/available/email
     * @param email
     * @param userId
     * @returns Observable<any>
     */
    checkIfEmailIsAvailable(email, userId = null) {
        return this._http.post(`${this.configs.apiUrl}/auth/available/email`, { email, userId }).pipe(take(1));
    }
    /**
     * Validator endpoint
     *
     * @link api/v2/available/phone
     * @param phone
     * @param userId
     * @returns Observable<any>
     */
    checkIfPhoneIsAvailable(phone, userId) {
        return this._http.post(`${this.configs.apiUrl}/auth/available/phone`, { phone, userId }).pipe(take(1));
    }
}
ValidatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: ValidatorService, deps: [{ token: FM_CONFIGS }, { token: i1$2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
ValidatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: ValidatorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: ValidatorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FM_CONFIGS]
                }] }, { type: i1$2.HttpClient }]; } });

/**
 * Usage:
 *  <input emailTakenValidator formControlName="email">
 *  <div *ngIf="form.get('email')?.hasError('emailTaken')">
 *    This email is already taken
 *  </div>
 *
 * <!-- Passing delay time -->
 * <input emailTakenValidator delay="1000" formControlName="email">
 *  <div *ngIf="form.get('email')?.hasError('emailTaken')">
 *    This email is already taken
 *  </div>
 */
class EmailTakenValidatorDirective {
    constructor(_validatorService) {
        this._validatorService = _validatorService;
        this._delay = 150;
    }
    set delay(value) {
        this._delay = +value;
    }
    validate(control) {
        if (control.hasError('email') || control.hasError('required')) {
            return EMPTY;
        }
        return timer(this._delay).pipe(switchMap(() => this._validatorService.checkIfEmailIsAvailable(control.value, this.user?.id).pipe(take(1), map$1((res) => (res.taken ? { emailTaken: true } : null)), tap((res) => control.setErrors(res)))));
    }
}
EmailTakenValidatorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: EmailTakenValidatorDirective, deps: [{ token: ValidatorService }], target: i0.ɵɵFactoryTarget.Directive });
EmailTakenValidatorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.6", type: EmailTakenValidatorDirective, selector: "[emailTakenValidator]", inputs: { delay: ["emailTakenValidatorDelay", "delay"], user: ["emailTakenValidtorUser", "user"] }, providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: EmailTakenValidatorDirective, multi: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: EmailTakenValidatorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[emailTakenValidator]',
                    providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: EmailTakenValidatorDirective, multi: true }],
                }]
        }], ctorParameters: function () { return [{ type: ValidatorService }]; }, propDecorators: { delay: [{
                type: Input,
                args: ['emailTakenValidatorDelay']
            }], user: [{
                type: Input,
                args: ['emailTakenValidtorUser']
            }] } });

/**
 * Usage:
 *  <input phoneTakenValidator formControlName="phone">
 *  <div *ngIf="form.get('phone')?.hasError('phoneTaken')">
 *    This phone is already taken
 *  </div>
 *
 * <!-- Passing delay time -->
 * <input phoneTakenValidator delay="1000" formControlName="phone">
 *  <div *ngIf="form.get('phone')?.hasError('phoneTaken')">
 *    This phone is already taken
 *  </div>
 */
class PhoneTakenValidatorDirective {
    constructor(_validatorService) {
        this._validatorService = _validatorService;
        this._delay = 150;
    }
    set delay(value) {
        this._delay = +value;
    }
    validate(control) {
        if (control.hasError('required')) {
            return EMPTY;
        }
        return timer(this._delay).pipe(switchMap(() => this._validatorService.checkIfPhoneIsAvailable(control.value.replaceAll(' ', ''), this.user?.id).pipe(take(1), map$1((res) => (res.taken ? { phoneTaken: true } : null)), tap((res) => control.setErrors(res)))));
    }
}
PhoneTakenValidatorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: PhoneTakenValidatorDirective, deps: [{ token: ValidatorService }], target: i0.ɵɵFactoryTarget.Directive });
PhoneTakenValidatorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.6", type: PhoneTakenValidatorDirective, selector: "[phoneTakenValidator]", inputs: { delay: ["phoneTakenValidatorDelay", "delay"], user: ["phoneTakenValidatorUser", "user"] }, providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: PhoneTakenValidatorDirective, multi: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: PhoneTakenValidatorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[phoneTakenValidator]',
                    providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: PhoneTakenValidatorDirective, multi: true }],
                }]
        }], ctorParameters: function () { return [{ type: ValidatorService }]; }, propDecorators: { delay: [{
                type: Input,
                args: ['phoneTakenValidatorDelay']
            }], user: [{
                type: Input,
                args: ['phoneTakenValidatorUser']
            }] } });

class FmDirectivesModule {
}
FmDirectivesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDirectivesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FmDirectivesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: FmDirectivesModule, declarations: [EmailTakenValidatorDirective, PhoneTakenValidatorDirective], exports: [EmailTakenValidatorDirective, PhoneTakenValidatorDirective] });
FmDirectivesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDirectivesModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: FmDirectivesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EmailTakenValidatorDirective, PhoneTakenValidatorDirective],
                    exports: [EmailTakenValidatorDirective, PhoneTakenValidatorDirective],
                }]
        }] });

/**
 * Public API Surface of fm-theme-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AwsService, Base, CountryCode, DialogEventTypes, EmailTakenValidatorDirective, Examples, FM_CONFIGS, FM_ERROR_CONFIG, FM_ERROR_HANDLER_CLASS, FmApps, FmAvatarComponent, FmAvatarModule, FmBadgeComponent, FmBadgeModule, FmDialogModule, FmDialogWarningComponent, FmDirectivesModule, FmDragAndDropComponent, FmDragAndDropDirective, FmDragAndDropModule, FmErrorHandler, FmErrorHandlerModule, FmErrorTypeEnum, FmFormGroup, FmIconComponent, FmIconModule, FmLoaderDirectiveModule, FmLogLevels, FmProgressComponent, FmProgressLoaderDirective, FmThemeLibModule, FmTimerDialogComponent, FmTimerModule, FmTimerService, FmTimerV2DialogComponent, FmTimerV2Service, FmUploaderComponent, FmUploaderModule, LacMatCountrySelectorComponent, LacMatTelInputComponent, LacMatTelInputModule, PhoneTakenValidatorDirective, Platforms, ProcessedCountryCode, defaultConfig$1 as defaultConfig, phoneNumberValidator };
